// 3D-19 full demo rebuild â€” smooth scroll + floating product fleet
// Always reload at the top. The whole page is scroll-driven, so the browser
// restoring a mid-page scroll position dropped you into a section whose 3D state
// had never been played in — products and tiles showed up already assembled in
// places they should not be. (Tom 08-09)
if ("scrollRestoration" in history) history.scrollRestoration = "manual";
window.scrollTo(0, 0);
window.addEventListener("beforeunload", () => window.scrollTo(0, 0));

/* Lenis is DESKTOP ONLY. On a phone its smoothed scroll sat a frame behind the
   fixed 3D canvas, which is what made the products judder. The first attempt
   destroyed it after construction — but the gsap ticker kept calling
   lenis.raf() on the dead instance every frame, that threw, the ticker died,
   and ScrollTrigger stopped updating altogether. That is why only the first
   product card ever appeared and why scrolling felt stuck. So it is simply
   never created on touch widths, and ScrollTrigger drives off native scroll.
   (Tom 08-10/11) */
const SMOOTH = window.innerWidth > 768;
/* ONE definition of "this is a phone", read once at load, used by every
   mobile-only branch in this file. It used to be declared halfway down, which
   meant anything above it could not ask the question. (Tom 08-11) */
const MOB = !SMOOTH;
/* AUTO-LITE (Tom 10-15, option 1: "draws fewer, simpler pieces on a slow computer").
   Laptops on integrated graphics (Tom's and Allison's AMD Radeon) could only draw the
   hero ~15 times a second. Measured on Tom's laptop, three cuts together doubled it
   (15 -> 32fps): no antialiasing, chrome without the clearcoat layer, and the 24k-
   triangle lite meshes instead of the 170k-triangle originals. Phones and dedicated or
   Apple GPUs keep the full look. ?lite=1 / ?lite=0 force it either way for QC. The
   decision is made once, before the renderer exists, because antialiasing cannot be
   switched on a live WebGL context. */
const LITE_MODE = (() => {
  const q = new URLSearchParams(location.search).get("lite");
  if (q === "1") return true;
  if (q === "0") return false;
  if (MOB) return false;
  try {
    const gl = document.createElement("canvas").getContext("webgl");
    const ext = gl && gl.getExtension("WEBGL_debug_renderer_info");
    const name = ext ? String(gl.getParameter(ext.UNMASKED_RENDERER_WEBGL)) : "";
    const lose = gl && gl.getExtension("WEBGL_lose_context"); if (lose) lose.loseContext();
    if (/apple|nvidia|geforce|rtx|quadro/i.test(name)) return false;
    return /intel|radeon ?\(tm\) graphics|radeon graphics|radeon vega|vega \d|uhd|iris|mali|adreno|swiftshader|llvmpipe|basic render/i.test(name);
  } catch (_) { return false; }
})();
window.__lite = LITE_MODE;   // QC handle
const lenis = SMOOTH ? new Lenis() : null;
window.lenis = lenis;   // QC probes drive the scroll through it
if (lenis) {
  lenis.on("scroll", ScrollTrigger.update);
  gsap.ticker.add((time) => { lenis.raf(time * 1000); });
}
gsap.ticker.lagSmoothing(0);

/* THE ONE VIEWPORT THE RENDERER AND THE PLACEMENT MATHS BOTH AGREE ON.
   Every product on this page is drawn into one fixed full-screen canvas and
   positioned each frame from a DOM rect, converted through the viewport size.
   That conversion has to use the SAME height the canvas was sized to — and on a
   phone those two had drifted apart: the resize handler deliberately ignores a
   height-only change on touch widths (the URL bar collapsing was making every
   product visibly grow), so renderer.setSize() and the cameras kept the old
   height while updateCollection() / drawCallouts() / the stage scissor all read
   window.innerHeight LIVE, every frame. Measured at 390px: dropping the height
   844 -> 790 left the canvas 844 tall against a 790 viewport, and every piece
   was drawn 27px (= half the difference) off its card — the bench piece hung
   over the stage border and the rail thumbnails sat on their own labels. That
   is the studio "glitch on scroll". These two are updated ONLY where
   renderer.setSize() is, so they can never disagree with it again. (Tom 08-11) */
let VW = window.innerWidth, VH = window.innerHeight;

// Scene
const scene = new THREE.Scene();
scene.background = null;

const camera = new THREE.PerspectiveCamera(
  75,
  VW / VH,
  0.1,
  1000
);
camera.position.z = 7;

const renderer = new THREE.WebGLRenderer({ antialias: !LITE_MODE, alpha: true });
/* PIN THE CANVAS TO sRGB. On a wide-gamut screen (every recent iPhone) Safari
   will hand a WebGL canvas a Display-P3 drawing buffer, and the same sRGB blue
   then paints deeper and darker there than it does on an sRGB desktop — which
   is exactly the "blue is darker only on iPhone" symptom. Asking for an sRGB
   buffer makes the phone and the desktop agree. No-op where it is already the
   default. (Tom 08-11) */
try {
  const gl = renderer.getContext();
  if (gl && "drawingBufferColorSpace" in gl) gl.drawingBufferColorSpace = "srgb";
  if (gl && "unpackColorSpace" in gl) gl.unpackColorSpace = "srgb";
} catch (_) {}
renderer.setClearColor(0x000000, 0);
renderer.setSize(VW, VH);
/* PIXEL RATIO IS CAPPED AT 2 ON A PHONE. An iPhone reports devicePixelRatio 3,
   and this canvas is full-screen and fixed, so it was being drawn at roughly
   1179 x 2532 = 3.0M pixels — and animate() runs two to four render passes over
   it every frame (the main scene, the card products, the scissored bench pass,
   any tile in flight). Capping at 2 is 1.33M pixels, a 56% cut in fragment work,
   for a difference the eye cannot resolve at this size. Desktop is untouched.
   (Tom 08-12/13: the scroll judder in the last two sections) */
renderer.setPixelRatio(MOB ? Math.min(window.devicePixelRatio, 2) : window.devicePixelRatio);
window.__renderer = renderer;   // QC handle (perf probes)
renderer.physicallyCorrectLights = true;
/* ACES stays ON — it is what gives the CHROME its contrast and mirror punch.
   Turning it off did make the tiles true, but it flattened the metal, and the
   metal is the approved look (Lessons 08-07). The tile-colour fix is therefore
   done on the PLASTIC material and its own environment instead: see
   makePlasticEnv + PLASTIC below. (Tom 08-10) */
renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure = 1.45;
renderer.outputEncoding = THREE.sRGBEncoding;
document.querySelector(".model").appendChild(renderer.domElement);

// jewelry-photography environment: giant soft gradient panels with dark
// strips between them — the classic silver-shoot lightbox. This is what
// paints long white-to-grey gradient sweeps + crisp dark edges on metal.
function makeJewelryEnv(rend) {
  const W = 1024, H = 512;
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const g = c.getContext("2d");

  // base: deep neutral — anything not a panel reads as a dark edge
  const base = g.createLinearGradient(0, 0, 0, H);
  base.addColorStop(0.0, "#3c3e42");
  base.addColorStop(0.55, "#26272b");
  base.addColorStop(1.0, "#101114");
  g.fillStyle = base; g.fillRect(0, 0, W, H);

  // giant feathered softbox panels (top-left, top-right, rear) — each a wide
  // vertical gradient from hot white to nothing
  function panel(cx, cy, w, h, peak) {
    // LINEAR strip light: soft vertical falloff, feathered ends — radial
    // pools read as round blobs in the metal; strips read as clean bands
    const pc = document.createElement("canvas");
    pc.width = Math.ceil(w * 2); pc.height = Math.ceil(h * 2);
    const pg = pc.getContext("2d");
    const vg = pg.createLinearGradient(0, 0, 0, pc.height);
    vg.addColorStop(0, "rgba(255,255,255,0)");
    vg.addColorStop(0.32, "rgba(255,255,255," + peak + ")");
    vg.addColorStop(0.68, "rgba(255,255,255," + peak + ")");
    vg.addColorStop(1, "rgba(255,255,255,0)");
    pg.fillStyle = vg; pg.fillRect(0, 0, pc.width, pc.height);
    const hg = pg.createLinearGradient(0, 0, pc.width, 0);
    hg.addColorStop(0, "rgba(0,0,0,0)");
    hg.addColorStop(0.18, "rgba(0,0,0,1)");
    hg.addColorStop(0.82, "rgba(0,0,0,1)");
    hg.addColorStop(1, "rgba(0,0,0,0)");
    pg.globalCompositeOperation = "destination-in";
    pg.fillStyle = hg; pg.fillRect(0, 0, pc.width, pc.height);
    g.drawImage(pc, cx - w, cy - h);
  }
  panel(W * 0.22, H * 0.28, 300, 120, 1.0);   // key strip
  panel(W * 0.68, H * 0.24, 250, 100, 0.85);  // second strip
  panel(W * 0.94, H * 0.42, 150, 70, 0.5);    // rear kicker
  panel(W * 0.45, H * 0.85, 260, 70, 0.22);   // floor bounce card

  // BLACK reflections: hard black cards flanking the key panels + the
  // camera/photographer silhouette dead ahead — these carve the dark bands
  // that define the metal's edges in real jewelry shots
    function flag(x, y, w, h) {
      // feathered black card — hard edges mirror every normal seam on the
      // metal into sawtooth; a scrim-soft edge sweeps smooth
      var grd = g.createLinearGradient(x - w * 0.6, 0, x + w * 1.6, 0);
      grd.addColorStop(0, "rgba(0,0,0,0)");
      grd.addColorStop(0.35, "rgba(0,0,0,0.92)");
      grd.addColorStop(0.65, "rgba(0,0,0,0.92)");
      grd.addColorStop(1, "rgba(0,0,0,0)");
      g.fillStyle = grd;
      g.fillRect(x - w * 0.6, y, w * 2.2, h);
    }
    flag(W * 0.355, H * 0.06, W * 0.065, H * 0.60);
    flag(W * 0.565, H * 0.08, W * 0.055, H * 0.55);
    flag(W * 0.055, H * 0.15, W * 0.05, H * 0.50);
    flag(W * 0.78, H * 0.12, W * 0.04, H * 0.45);
    var og = g.createLinearGradient(0, 0, 0, H * 0.09);
    og.addColorStop(0, "rgba(0,0,0,0.9)");
    og.addColorStop(1, "rgba(0,0,0,0)");
    g.fillStyle = og; g.fillRect(W * 0.18, 0, W * 0.32, H * 0.09);
    g.fillStyle = "rgba(10,10,12,0.85)";
    g.fillRect(W * 0.475, H * 0.38, W * 0.05, H * 0.20);
    g.beginPath(); g.arc(W * 0.5, H * 0.44, 14, 0, Math.PI * 2); g.fill();

  // thin hot strip light — the sharp white line jewelry shots love
  const strip = g.createLinearGradient(0, H * 0.12, 0, H * 0.20);
  strip.addColorStop(0, "rgba(255,255,255,0)");
  strip.addColorStop(0.5, "rgba(255,255,255,0.95)");
  strip.addColorStop(1, "rgba(255,255,255,0)");
  g.fillStyle = strip; g.fillRect(W * 0.30, H * 0.12, W * 0.34, H * 0.08);

  const tex = new THREE.CanvasTexture(c);
  tex.mapping = THREE.EquirectangularReflectionMapping;
  const pm = new THREE.PMREMGenerator(rend);
  const rt = pm.fromEquirectangular(tex);
  pm.dispose(); tex.dispose();
  return rt.texture;
}
scene.environment = makeJewelryEnv(renderer);

scene.add(new THREE.HemisphereLight(0xffffff, 0x9a9a97, 0.5));
const key = new THREE.DirectionalLight(0xffffff, 1.1);
key.position.set(3, 6, 5);
scene.add(key);
const fill = new THREE.DirectionalLight(0xffffff, 0.45);
fill.position.set(-5, 2, -4);
scene.add(fill);
const rim = new THREE.DirectionalLight(0xffffff, 0.7);
rim.position.set(0, -4, -6);
scene.add(rim);

/* THE LOADING LOOP MUST ACTUALLY STOP. It used to be stopped with
   cancelAnimationFrame(basicAnimate) - a function, not a frame id, which cancels
   nothing - so once animate() took over, the whole scene was drawn TWICE every
   frame for the life of the page, and drawn even while animate() had paused the
   canvas. Measured on Tom's AMD laptop: the hero ran ~12fps with it. (Tom 10-15) */
let basicRAF = 0, basicOn = true;
function basicAnimate() {
  if (!basicOn) return;
  renderer.render(scene, camera);
  basicRAF = requestAnimationFrame(basicAnimate);
}
basicAnimate();
function stopBasic() { basicOn = false; cancelAnimationFrame(basicRAF); }

// THE CLICK — real product fleet, chrome (studio recipe)
const CHROME = () => LITE_MODE
  ? new THREE.MeshStandardMaterial({ color: 0xdcdfe2, metalness: 1.0, roughness: 0.07, envMapIntensity: 1.15, side: THREE.DoubleSide })   // auto-lite: no clearcoat pass
  : new THREE.MeshPhysicalMaterial({ color: 0xdcdfe2, metalness: 1.0, roughness: 0.07, clearcoat: 0.7, clearcoatRoughness: 0.08, envMapIntensity: 1.15, side: THREE.DoubleSide });

const products = new THREE.Group();
scene.add(products);

// [x, y, z, scale(units tall), phase, tumble]
const SPREAD = [
  [ 0.2,  0.0,  0.6, 3.2, 2.1, 0.0],   // HERO / MAIN PRODUCT: the click-screen spot — ONE position for the whole page (Tom 08-09)
  [-4.3,  1.9, -1.2, 2.6, 0.0, 0.9],   // round stud, upper-left
  [ 3.9,  2.2, -1.0, 3.0, 1.3, 1.1],   // 1x1 square huggie chain, upper-right
  [-3.3, -2.2, -1.2, 3.2, 3.2, 0.8],   // 1x2 huggie chain, lower-left
  [ 3.6, -2.3, -1.3, 3.0, 4.4, 1.0],   // 1x3 pendant + bail, lower-right
  [ 0.0,  3.3, -2.0, 2.9, 5.0, 1.2],   // 2x2 pendant + bail, top CENTER (Tom 08-08)
  [-5.6, -0.2, -1.6, 1.1, 0.7, 1.4],   // tile: square BLUE, far left
  [ 6.24, 0.1, -1.6, 1.1, 1.9, 1.3],   // tile: square GREEN, far right (moved right twice, 15px each — Tom 08-09; 0.22 world = 15px at this depth)
  [ 1.9, -3.3, -1.0, 1.1, 3.7, 1.5],   // tile: round RED, low
  [-0.6, -3.6, -1.8, 1.1, 5.3, 1.2],   // tile: round YELLOW, low-left
];

// true vibrant colors — same as the tinted-letter text (blue/yellow/red/kelly green #4CBB17)
const LEGO = { blue: 0x0000FF, green: 0x4CBB17, red: 0xFF0000, yellow: 0xFFFF00 };

// studs: more forward-facing (Tom 08-08) — enough tilt kept to show post + backing
const STUD_POSE = [1.1, 0.0, 0.3];
// hero sits dead-centre so perspective hides its post — yaw swings the post into
// view like the round stud reads, x past 1.57 tips the face ~5deg down (Tom 08-08)
const HERO_STUD_POSE = [0.82, 0.42, 0.78];  // midpoint forward<->profile: face reads, post+backing still clear (Tom 08-08)

const FLEET = [
  // REVERTED off the Y-axis spin (Tom 08-10): the hero is back on the upright
  // rig — gentle side-to-side rock, exactly as it was. Its continuous turn is
  // now on the HORIZONTAL axis instead, end-over-end, the same axis the other
  // products use for their exit spin. See the upright branch in the animate loop.
  { file: "stud-earring-1x1-square.stl", i: 0, hero: true, upright: true, pose: HERO_STUD_POSE },
  { file: "stud-earring-1x1-round.stl",  i: 1, upright: true, pose: STUD_POSE },
  { file: "click-hoop-1x1-square.stl",   i: 2, sway: true, yaw: Math.PI / 2 },   // huggie STLs face +90 (flip-tested)
  { file: "click-hoop-1x2.stl",          i: 3, sway: true, yaw: Math.PI / 2 },
  { file: "pendant-1x3-bail.stl",        i: 4, sway: true, yaw: Math.PI },
  { file: "pendant-2x2-bail.stl",        i: 5, sway: true, yaw: Math.PI },
  { file: "tile-1x1-square.stl",         i: 6, plastic: LEGO.blue,   upright: true, spin: true, pose: [0.65,  0.5, 0] },   // tiles: top + side, spinning
  { file: "tile-1x1-square.stl",         i: 7, plastic: LEGO.green,  upright: true, spin: true, pose: [0.65, -0.5, 0] },
  { file: "tile-1x1-round.stl",          i: 8, plastic: LEGO.red,    upright: true, spin: true, pose: [0.75,  0,   0] },
  { file: "tile-1x1-round.stl",          i: 9, plastic: LEGO.yellow, upright: true, spin: true, pose: [0.75,  0,   0] },
];

// plastic gets its own single-softbox reflection world — the jewelry env's
// bright panels wash colored gloss out (studio lesson)
let plasticEnvTex = null;
function makePlasticEnv(rend) {
  const W = 1024, H = 512;
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const g = c.getContext("2d");
  /* BRIGHT neutral room. This env lights the plastic tiles only (CHROME has no
     envMap of its own and rides scene.environment, so the metal is untouched).
     It used to be the same near-black jewelry-shoot room the metal uses —
     which meant every tile was lit by a black room and rendered dark and
     desaturated: LEGO Yellow came out olive. Plastic needs a lit room for its
     albedo to read true. (Tom 08-10) */
  const base = g.createLinearGradient(0, 0, 0, H);
  base.addColorStop(0, "#ffffff");
  base.addColorStop(0.6, "#e9eaec");
  base.addColorStop(1, "#c9ccd1");
  g.fillStyle = base; g.fillRect(0, 0, W, H);
  const pc = document.createElement("canvas");
  pc.width = 560; pc.height = 200;
  const pg = pc.getContext("2d");
  const vg = pg.createLinearGradient(0, 0, 0, 200);
  vg.addColorStop(0, "rgba(255,255,255,0)");
  vg.addColorStop(0.3, "rgba(255,255,255,1)");
  vg.addColorStop(0.7, "rgba(255,255,255,1)");
  vg.addColorStop(1, "rgba(255,255,255,0)");
  pg.fillStyle = vg; pg.fillRect(0, 0, 560, 200);
  const hg = pg.createLinearGradient(0, 0, 560, 0);
  hg.addColorStop(0, "rgba(0,0,0,0)");
  hg.addColorStop(0.2, "rgba(0,0,0,1)");
  hg.addColorStop(0.8, "rgba(0,0,0,1)");
  hg.addColorStop(1, "rgba(0,0,0,0)");
  pg.globalCompositeOperation = "destination-in";
  pg.fillStyle = hg; pg.fillRect(0, 0, 560, 200);
  g.drawImage(pc, W * 0.16, H * 0.10);
  const tex = new THREE.CanvasTexture(c);
  tex.mapping = THREE.EquirectangularReflectionMapping;
  const pm = new THREE.PMREMGenerator(renderer);
  const rt = pm.fromEquirectangular(tex);
  pm.dispose(); tex.dispose();
  return rt.texture;
}

const PLASTIC = (hex) => {
  if (!plasticEnvTex) plasticEnvTex = makePlasticEnv(renderer);
  /* clearcoat 1.0 -> 0.35 and env 0.9 -> 0.45: a full clearcoat lays a white
     veil over the albedo, which pushed every tile off its swatch. Still glossy
     ABS, just not washed out. (Tom 08-10) */
  /* emissive carries the EXACT swatch hue. All plastic light here comes from
     the env (physicallyCorrectLights, no direct lamps on the tiles), so env
     alone can never be right: turn it down and the tile goes dark, turn it up
     and white washes the hue out. Emissive injects the true colour
     independently of the lighting, and diffuse + a light clearcoat still do
     the 3D shading. (Tom 08-10) */
  return new THREE.MeshPhysicalMaterial({ color: hex, metalness: 0.0, roughness: 0.38,
    emissive: hex, emissiveIntensity: 0.10,
    clearcoat: 0.20, clearcoatRoughness: 0.14,
    envMap: plasticEnvTex, envMapIntensity: 0.13, side: THREE.DoubleSide });
};


  // angle-aware smooth normals: average only faces meeting within ~42deg.
  // Smooths curves, keeps machined edges crisp — and kills the star-shaped
  // shading artifacts where flat faces fan around holes.
  function angleNormals(g, degrees) {
    var cos = Math.cos((degrees || 42) * Math.PI / 180);
    var idx = g.getIndex().array, pos = g.getAttribute('position').array;
    var nf = idx.length / 3;
    var fn = new Float32Array(nf * 3);
    for (var f = 0; f < nf; f++) {
      var a = idx[f*3], b = idx[f*3+1], c = idx[f*3+2];
      var ax = pos[a*3], ay = pos[a*3+1], az = pos[a*3+2];
      var ux = pos[b*3]-ax, uy = pos[b*3+1]-ay, uz = pos[b*3+2]-az;
      var vx = pos[c*3]-ax, vy = pos[c*3+1]-ay, vz = pos[c*3+2]-az;
      var x = uy*vz-uz*vy, y = uz*vx-ux*vz, z = ux*vy-uy*vx;
      var l = Math.sqrt(x*x+y*y+z*z) || 1;
      fn[f*3] = x/l; fn[f*3+1] = y/l; fn[f*3+2] = z/l;
    }
    var vf = [];
    for (var i = 0; i < pos.length/3; i++) vf.push([]);
    for (var f2 = 0; f2 < nf; f2++) {
      vf[idx[f2*3]].push(f2); vf[idx[f2*3+1]].push(f2); vf[idx[f2*3+2]].push(f2);
    }
    var out = new Float32Array(idx.length * 3);
    for (var f3 = 0; f3 < nf; f3++) {
      var fx = fn[f3*3], fy = fn[f3*3+1], fz = fn[f3*3+2];
      for (var k = 0; k < 3; k++) {
        var vi = idx[f3*3+k];
        var sx = 0, sy = 0, sz = 0;
        var faces = vf[vi];
        for (var q = 0; q < faces.length; q++) {
          var o = faces[q];
          if (fn[o*3]*fx + fn[o*3+1]*fy + fn[o*3+2]*fz >= cos) {
            sx += fn[o*3]; sy += fn[o*3+1]; sz += fn[o*3+2];
          }
        }
        var sl = Math.sqrt(sx*sx+sy*sy+sz*sz) || 1;
        var w = (f3*3+k)*3;
        out[w] = sx/sl; out[w+1] = sy/sl; out[w+2] = sz/sl;
      }
    }
    // rebuild as non-indexed with per-corner normals
    var np = new Float32Array(idx.length * 3);
    for (var t = 0; t < idx.length; t++) {
      np[t*3] = pos[idx[t]*3]; np[t*3+1] = pos[idx[t]*3+1]; np[t*3+2] = pos[idx[t]*3+2];
    }
    var g2 = new THREE.BufferGeometry();
    g2.setAttribute('position', new THREE.BufferAttribute(np, 3));
    g2.setAttribute('normal', new THREE.BufferAttribute(out, 3));
    return g2;
  }

function parseSTL(buf) {
  const dv = new DataView(buf);
  const n = dv.getUint32(80, true);
  // weld shared vertices so curved surfaces shade smooth — unwelded STL
  // triangles all shade flat, which is what read as fake plastic
  const map = new Map();
  const verts = [];
  const index = [];
  for (let i = 0; i < n; i++) {
    const o = 84 + i * 50;
    for (let v = 0; v < 3; v++) {
      const q = o + 12 + v * 12;
      const x = dv.getFloat32(q, true), y = dv.getFloat32(q + 4, true), z = dv.getFloat32(q + 8, true);
      const key = ((x * 1e4) | 0) + "_" + ((y * 1e4) | 0) + "_" + ((z * 1e4) | 0);
      let id = map.get(key);
      if (id === undefined) {
        id = verts.length / 3;
        verts.push(x, y, z);
        map.set(key, id);
      }
      index.push(id);
    }
  }
  const g = new THREE.BufferGeometry();
  g.setAttribute("position", new THREE.BufferAttribute(new Float32Array(verts), 3));
  g.setIndex(index);
  return angleNormals(g, 42);
}

/* ---- one shared geometry cache for the WHOLE page ----------------------
   Models ship as Draco-compressed GLB, not raw STL: the five pendants were
   ~8MB each and the page pulled 72MB on load. The GLBs hold the SAME geometry
   (identical triangle counts, exported Z-up so the -PI/2 rotation downstream
   still applies) — they are only welded at the same 1e-4 tolerance parseSTL
   used, then Draco-encoded. 51.84MB -> 0.79MB, 66x smaller.
   Rebuild with: blender -b -P scripts/the-click-stl2glb.py -- <in> <out>
   parseSTL stays as the fallback for any piece with no .glb.
   The hero fleet and the studio both go through here now; before, each
   fetched independently and five models downloaded twice. (Tom 08-10) */
const geoCache = new Map();
let _gltf = null;
function gltf() {
  if (!_gltf) {
    _gltf = new THREE.GLTFLoader();
    const d = new THREE.DRACOLoader();
    // self-hosted: a CDN decoder sits in the critical path and costs a
    // round-trip before the first piece can appear (Tom 08-10)
    d.setDecoderPath(window.TC_BASE);
    d.setDecoderConfig({ type: "wasm" });
    _gltf.setDRACOLoader(d);
  }
  return _gltf;
}

function centerGeo(g) {
  g.computeBoundingBox();
  const c = new THREE.Vector3();
  g.boundingBox.getCenter(c);
  g.translate(-c.x, -c.y, -c.z);
  g.computeBoundingBox();
  return g;
}

// auto-lite: every pendant, huggie and stud uses its lite mesh; a missing lite file falls back to full
function loadGeo(model) {
  if (LITE_MODE && !model.startsWith("lite-") && /^(pendant-|click-hoop-|stud-earring-)/.test(model))
    return loadGeoRaw("lite-" + model).catch(() => loadGeoRaw(model));
  return loadGeoRaw(model);
}
function loadGeoRaw(model) {
  if (!geoCache.has(model)) {
    const glb = window.TC_BASE + "the-click-" + model.replace(/\.stl$/i, ".glb");
    const p = new Promise((res, rej) => {
      gltf().load(glb, (data) => {
        let geo = null;
        data.scene.traverse((o) => { if (!geo && o.isMesh) geo = o.geometry; });
        if (!geo) return rej(new Error("no mesh in " + glb));
        // the same 42deg angle-aware normals the STL path produced; the welded
        // GLB just skips the client-side weld, nothing else changes
        res(centerGeo(angleNormals(geo, 42)));
      }, undefined, rej);
    }).catch(() => fetch("./assets/models/" + model)
      .then((r) => r.arrayBuffer())
      .then((buf) => centerGeo(parseSTL(buf))));
    geoCache.set(model, p);
  }
  return geoCache.get(model);
}

let heroCan = null;
const floaters = [];

function seat(mesh, i, upright, pose, sway, yaw) {
  const [x, y, z, s, ph, ts] = SPREAD[i];
  mesh.position.set(x, y, z);
  mesh.scale.setScalar(0);
  mesh.userData = { baseX: x, baseY: y, baseZ: z, phase: ph, tumble: ts, scale: 1, upright: !!upright, sway: !!sway, exitSpin: 0 };
  if (sway) {
    mesh.rotation.set(0.12, yaw || 0, 0);   // pendants/huggies: front-facing, rock side to side
  } else if (upright) {
    if (pose) mesh.rotation.set(pose[0], pose[1], pose[2]);   // reference tilt (Tom 08-08)
    else mesh.rotation.set(0.35, 0.35, 0);
  } else {
    mesh.rotation.set(Math.random() * 0.6 - 0.3, Math.random() * 6, Math.random() * 0.6 - 0.3);
  }
  mesh.userData.yaw0 = mesh.rotation.y;     // front anchor — oscillation centers here, never leaves it
  mesh.userData.tilt0 = mesh.rotation.x;    // base tilt — the horizontal-axis exit spin adds on top
  products.add(mesh);
  floaters.push(mesh);
}
window.__floaters = floaters;               // QC handle

let tileGeo = null;        // square-tile geometry, reused for the solo click-on sequence
let tileRoundGeo = null;   // round-tile geometry, for the round products
let loadedCount = 0;
FLEET.forEach((item) => {
  // through the shared cache — this used to be its own fetch, so any model the
  // studio also uses was downloaded twice (Tom 08-10)
  loadGeo(item.file)
    .then((g) => {
      const sz = g.boundingBox.getSize(new THREE.Vector3());
      const mesh = new THREE.Mesh(g, item.plastic ? PLASTIC(item.plastic) : CHROME());
      mesh.rotation.x = -Math.PI / 2;              // STL Z-up -> three Y-up
      const wrap = new THREE.Group();
      wrap.add(mesh);
      const target = SPREAD[item.i][3] * 1.2;   // everything 20% bigger (Tom 08-08)
      const norm = target / Math.max(sz.x, sz.y, sz.z);
      mesh.scale.setScalar(norm);
      seat(wrap, item.i, item.upright, item.pose, item.sway, item.yaw);
      wrap.userData.spin = !!item.spin;
      if (item.i === 6) tileGeo = g;
      if (item.i === 8) tileRoundGeo = g;   // round tile, for the round products (Tom 08-09)
      if (item.hero) {
        heroCan = wrap;
        heroCan.userData.mats = [];
        wrap.traverse((n) => { if (n.isMesh) heroCan.userData.mats.push(n.material); });
      }
      loadedCount++;
      if (loadedCount === FLEET.length) {
        buildClickTiles();
        faceStud(true);          // the click-screen pose, set ONCE, held for the whole page (Tom 08-09)
        intro();
        stopBasic();
        animate();
      }
    })
    .catch((e) => {
      console.error("model failed:", item.file, e);
      loadedCount++;
      if (loadedCount === FLEET.length) {
        intro();
        stopBasic();
        animate();
      }
    });
});

const floatAmp = 0.2;
const floatSpd = 1.5;
let scrollY = 0;

/* The scanner beep is GONE (Tom 08-11: no sound when you scroll past the first
   product card block). The Audio object and its preload went with it — nothing
   else on the page played a sound. */
const vh = window.innerHeight;

function intro() {
  floaters.forEach((f, i) => {
    gsap.to(f.scale, {
      x: f.userData.scale, y: f.userData.scale, z: f.userData.scale,
      duration: 1, delay: i * 0.08, ease: "power2.out",
    });
  });
}

// fleet (minus the can) leaves after the hero
ScrollTrigger.create({
  trigger: ".statement",
  start: "top 45%",                              // fleet leaves only when the NEXT section takes over
  onEnter: () => {
    floaters.forEach((f, i) => {
      if (f !== heroCan) {
        gsap.to(f.scale, { x: 0, y: 0, z: 0, duration: 1.1, delay: i * 0.06, ease: "power2.in" });
        gsap.to(f.userData, { exitSpin: Math.PI * 2, duration: 1.1, delay: i * 0.06, ease: "power2.inOut" });   // each does a full 360 on the way out
      }
    });
  },
  onLeaveBack: () => {
    floaters.forEach((f) => {
      gsap.to(f.scale, {
        x: f.userData.scale, y: f.userData.scale, z: f.userData.scale,
        duration: 0.8, ease: "power2.out",
      });
      // the hero is excluded — its exitSpin is a running total driven by the
      // section triggers below, and resetting it here would snap it backwards
      if (f !== heroCan) gsap.to(f.userData, { exitSpin: 0, duration: 0.8, ease: "power2.out" });
    });
  },
});

/* MAIN PRODUCT — levitates as it always did, and every time a new section takes
   over it does the SAME end-over-end turn the other pieces do on their way out.
   It never shrinks and never leaves; only the rotation is borrowed. exitSpin is
   a running total so each trigger adds turns instead of resetting to a pose.
   (Tom 08-10: "just levitating in the middle and its really boring") */
let heroTurns = 0;
function spinHero() {
  if (!heroCan) return;
  // ONE 360, at the exact duration + ease the other pieces use for their exit
  // spin (Math.PI*2 / 1.1s / power2.inOut). Same move, just without leaving.
  heroTurns += Math.PI * 2;
  gsap.to(heroCan.userData, { exitSpin: heroTurns, duration: 1.1, ease: "power2.inOut", overwrite: true });
}
/* THREE spins over the whole page, not one per section — seven triggers meant
   seven turns and it read as constant motion. (Tom 08-10)

   MOBILE takes .callouts where the web build takes .thinking. On a phone the
   sections are short, so .thinking's "top 70%" fires while .solo — the screen
   where the coloured tiles click on — is still filling the viewport: you got the
   .statement turn and then the .thinking turn back to back, i.e. the product
   spun TWICE during the colour-changing screen. Handing that second turn to the
   NEXT section moves it off .solo entirely without losing a spin. Web is
   unchanged. (Tom 08-11) */
/* WEB gains a FOURTH turn, at .callouts — Tom 08-12: "make the main product 360
   spin one more time before the how a base is made section". The trigger fires at
   "top 70%", i.e. while HOW A BASE IS MADE is still coming up the screen, so the
   turn lands before the section arrives rather than during it. Mobile already
   takes its second turn there (see above) and is unchanged. */
(MOB ? [".statement", ".callouts", ".scanner"]
     : [".statement", ".thinking", ".callouts", ".scanner"]).forEach((sel) => {
  if (!document.querySelector(sel)) return;
  ScrollTrigger.create({
    trigger: sel,
    start: "top 70%",
    onEnter: spinHero,
    onEnterBack: spinHero,
  });
});

// ---- solo screen: colored square tiles CLICK onto the stud face and off as you scroll ----
const clickTiles = [];
let clickSeat = null, clickDir = null, soloPose = null;

function buildClickTiles() {
  if (!heroCan || !tileGeo) return;
  const heroMesh = heroCan.children[0];
  const s = heroMesh.scale.x;
  const hb = heroMesh.geometry.boundingBox;
  const size = new THREE.Vector3(); hb.getSize(size);

  // post axis = longest STL axis; the plate sits at the WIDE end of it
  const axes = ["x", "y", "z"];
  let post = "x";
  axes.forEach((a) => { if (size[a] > size[post]) post = a; });
  const others = axes.filter((a) => a !== post);
  const pos = heroMesh.geometry.attributes.position;
  let wide = { pos: 0, neg: 0 };
  for (let i = 0; i < pos.count; i += 5) {
    const v = { x: pos.getX(i), y: pos.getY(i), z: pos.getZ(i) };
    const r = Math.hypot(v[others[0]], v[others[1]]);
    if (v[post] > size[post] * 0.3) wide.pos = Math.max(wide.pos, r);
    else if (v[post] < -size[post] * 0.3) wide.neg = Math.max(wide.neg, r);
  }
  const sign = wide.pos > wide.neg ? 1 : -1;
  const faceAlong = sign > 0 ? hb.max[post] : hb.min[post];

  const tb = tileGeo.boundingBox || (tileGeo.computeBoundingBox(), tileGeo.boundingBox);
  const ts = new THREE.Vector3(); tb.getSize(ts);
  const tileThick = Math.min(ts.x, ts.y, ts.z);

  // STL-space face normal + seat point (studs sink into the tile a touch).
  // Cross-axis centre comes from the face-end VERTICES — the bbox centre is
  // skewed by the butterfly backing, which is what left the tile floating off-plate.
  const nSTL = new THREE.Vector3(); nSTL[post] = sign;
  let cx = 0, cy = 0, cn = 0;
  for (let i = 0; i < pos.count; i += 3) {
    const v = { x: pos.getX(i), y: pos.getY(i), z: pos.getZ(i) };
    if (sign > 0 ? v[post] > faceAlong - size[post] * 0.10 : v[post] < faceAlong + size[post] * 0.10) {
      cx += v[others[0]]; cy += v[others[1]]; cn++;
    }
  }
  const seatSTL = new THREE.Vector3();
  seatSTL[others[0]] = cn ? cx / cn : 0;
  seatSTL[others[1]] = cn ? cy / cn : 0;
  seatSTL[post] = faceAlong + sign * tileThick * 0.18;

  // map STL space -> wrap space (the -PI/2 X rotation every mesh gets)
  const qX = new THREE.Quaternion().setFromEuler(new THREE.Euler(-Math.PI / 2, 0, 0));
  clickSeat = seatSTL.clone().applyQuaternion(qX).multiplyScalar(s);
  clickDir = nSTL.clone().applyQuaternion(qX);
  clickSeat.addScaledVector(clickDir, -0.24);   // fully seated — only the tile lip's hairline gap remains (Tom 08-08)
  // pose that aims the stud's FACE straight at the camera — the tiles click on
  // toward the viewer instead of side-on (Tom 08-08)
  soloPose = new THREE.Euler().setFromQuaternion(
    new THREE.Quaternion().setFromUnitVectors(clickDir, new THREE.Vector3(0, 0, 1)), "XYZ"
  );
  const qFace = new THREE.Quaternion().setFromUnitVectors(new THREE.Vector3(0, 0, 1), nSTL);

  [LEGO.blue, LEGO.green, LEGO.red, LEGO.yellow].forEach((col) => {
    const m = new THREE.Mesh(tileGeo, PLASTIC(col));
    m.quaternion.copy(qX).multiply(qFace);
    m.scale.setScalar(s);
    m.position.copy(clickSeat);
    m.visible = false;
    heroCan.add(m);
    clickTiles.push(m);
  });
  window.__ct = { tiles: clickTiles, seat: clickSeat, dir: clickDir, set: setClickTiles };   // QC handle
}

function setClickTiles(p) {
  if (!clickTiles.length) return;
  const active = p > 0.002 && p < 0.998;
  const seg = Math.min(3.999, Math.max(0, p) * 4);
  const idx = seg | 0, lp = seg - idx;
  let k;                                        // 0 = far away, 1 = clicked on
  if (lp < 0.32) k = lp / 0.32;
  else if (lp < 0.72) k = 1;               // wider hold — tile stays fully clicked ON (Tom 08-08: stopped short)
  else k = (1 - lp) / 0.28;
  k = k * k * (3 - 2 * k);                      // smooth click in / click off
  clickTiles.forEach((m, i) => {
    m.visible = active && i === idx;
    if (i === idx) {
      m.position.copy(clickSeat).addScaledVector(clickDir, (1 - k) * 2.4);
    }
  });
}

// face the stud FRONT-ON for the click sequence, back to its angled hero pose after
// Click sequence: NOT a flat front view — stays isometric (a little more front
// than side) and drifts front <-> semi-side forever, so the post and butterfly
// are always in shot. (Tom 08-08)
function mixPose(a, b, k) { return [0, 1, 2].map((i) => a[i] + (b[i] - a[i]) * k); }
function faceStud(front) {
  if (!heroCan || !soloPose) return;
  const u = heroCan.userData;
  if (front) {
    const dead = [soloPose.x, soloPose.y, soloPose.z];
    u.poseA = mixPose(dead, HERO_STUD_POSE, 0.62);   // mostly front, post + butterfly still in shot
    u.poseB = mixPose(dead, HERO_STUD_POSE, 1.0);    // semi-side (the approved hero angle)
    u.floatPose = true;
  } else {
    u.floatPose = false;
    gsap.to(u, { tilt0: HERO_STUD_POSE[0], yaw0: HERO_STUD_POSE[1], duration: 0.7, ease: "power2.inOut" });
    gsap.to(heroCan.rotation, { z: HERO_STUD_POSE[2], duration: 0.7, ease: "power2.inOut" });
  }
}
// ONE main-product rig (Tom 08-09): the click-screen pose is the ONLY pose the
// main product ever holds — it is set once, at build, and never toggled again.
// The old .solo enter/leave toggle + the .statement drift + the .thinking
// resize were three rigs fighting over the same object, which is what made a
// "new" product appear at the color-tile section.

ScrollTrigger.create({
  trigger: ".solo",
  start: "top top",
  end: "+=200%",
  pin: true,
  onUpdate: (self) => setClickTiles(self.progress),
  onLeave: () => clickTiles.forEach((m) => (m.visible = false)),
  onLeaveBack: () => clickTiles.forEach((m) => (m.visible = false)),
});

// (the .statement "drift to centre" rig is GONE — SPREAD[0] IS that spot now,
//  so the main product is already there and never has to move. Tom 08-09)

// ---- THE DECK: one card design, 12 products, all inside the scanner section.
// #01 assembles, then #02 arrives and #01 slides left, #03 goes right, and the
// rest keep filling the 3-wide grid as you scroll (Tom 08-08). ----
// The card products render through their OWN orthographic pass. The main 75deg
// perspective camera fish-eyes anything off-centre (bails stretched, pieces in
// the side columns reading bigger) — ortho has zero distortion, so every card
// shows its product at exactly the same size and angle. (Tom 08-08)
const deckScene = new THREE.Scene();
deckScene.environment = scene.environment;
deckScene.add(new THREE.HemisphereLight(0xffffff, 0x9a9a97, 0.5));
[[3, 6, 5, 1.1], [-5, 2, -4, 0.45], [0, -4, -6, 0.7]].forEach(([x, y, z, i]) => {
  const l = new THREE.DirectionalLight(0xffffff, i);
  l.position.set(x, y, z);
  deckScene.add(l);
});
// A tile in flight lives HERE, not in the deck scene, and this scene is drawn
// last over a cleared depth buffer. That is what keeps a tile in front of the
// jewelry the whole way in no matter which way the piece is turned — while
// still depth-testing against ITSELF, so you never see through into the shell.
// Forcing it with depthTest:false did the first job and broke the second.
// (Tom 08-09: "it should always be on the front of the jewelry and then click in")
const flyScene = new THREE.Scene();
flyScene.environment = scene.environment;
flyScene.add(new THREE.HemisphereLight(0xffffff, 0x9a9a97, 0.5));
[[3, 6, 5, 1.1], [-5, 2, -4, 0.45], [0, -4, -6, 0.7]].forEach(([x, y, z, i]) => {
  const l = new THREE.DirectionalLight(0xffffff, i);
  l.position.set(x, y, z);
  flyScene.add(l);
});
// mirrors the host wrap's world transform, so a tile keeps its exact local seat
// while it is parked here and lands identically when it goes home
const flyWrap = new THREE.Group();
flyScene.add(flyWrap);
let flyHost = null;
function syncFlyWrap() {
  if (!flyHost || !flyWrap.children.length) return;
  flyHost.updateMatrixWorld(true);
  flyHost.matrixWorld.decompose(flyWrap.position, flyWrap.quaternion, flyWrap.scale);
}

const deckCam = new THREE.OrthographicCamera(-1, 1, 1, -1, -4000, 4000);
deckCam.position.set(0, 0, 2000);          // parallel view = identical reflections on every card
function sizeDeckCam() {
  const W = VW, H = VH;
  deckCam.left = -W / 2; deckCam.right = W / 2;      // 1 world unit == 1 screen pixel
  deckCam.top = H / 2; deckCam.bottom = -H / 2;
  deckCam.updateProjectionMatrix();
}
sizeDeckCam();

const deckPieceOf = new Map();   // card element -> its 3D piece (filled by the loader below)
const DECK = [
  // every desc is written to fill exactly THREE lines in the card, so all
  // twelve cards have an identical text block and the buy row sits on one
  // baseline across the grid (Tom 08-09)
  { model: "stud-earring-1x1-round.stl",   kind: "stud",    name: "Stud Earring · Round", price: "$24",
    desc: "Real jewelry first: 12mm hypoallergenic post, locking notch, tight friction back. Its round face carries the brick interface — snap a tile on." },
  { model: "click-hoop-1x1-square.stl",    kind: "hoop",    name: "Huggie · 1x1 Square",  price: "$34",
    desc: "A hinged huggie that clicks shut on the lobe, with the brick interface on its square drop — snap a tile on and change the look in seconds." },
  { model: "click-hoop-1x1-round.stl",     kind: "hoop",    name: "Huggie · 1x1 Round",   price: "$34",
    desc: "A hinged huggie that clicks shut on the lobe, with the brick interface on its round drop — snap a tile on and change the look in seconds." },
  { model: "click-hoop-1x2.stl",           kind: "hoop",    name: "Huggie · 1x2",         price: "$34",
    desc: "A hinged huggie that clicks shut on the lobe, carrying two studs on the drop — stack a pair of tiles, mix the colors, or leave it plain." },
  { model: "click-hoop-1x3.stl",           kind: "hoop",    name: "Huggie · 1x3",         price: "$34",
    desc: "A hinged huggie that clicks shut on the lobe, carrying three studs on the drop — stack a run of tiles, mix the colors, or leave it plain." },
  { model: "click-hoop-2x2.stl",           kind: "hoop",    name: "Huggie · 2x2",         price: "$34",
    desc: "A hinged huggie that clicks shut on the lobe, with a full four-stud face — the widest canvas in the earring range, and the boldest to stack." },
  { model: "pendant-1x1-round-bail.stl",   kind: "pendant", name: "Pendant · 1x1 Round",  price: "$29",
    desc: "A closed-bail pendant that hangs on any chain, with the brick interface on its round face — snap a tile on and change the look in seconds." },
  { model: "pendant-1x1-square-bail.stl",  kind: "pendant", name: "Pendant · 1x1 Square", price: "$29",
    desc: "A closed-bail pendant that hangs on any chain, with the brick interface on its square face — snap a tile on and change the look in seconds." },
  { model: "pendant-1x2-bail.stl",         kind: "pendant", name: "Pendant · 1x2",        price: "$29",
    desc: "A closed-bail pendant that hangs on any chain, carrying two studs on the face — stack a pair of tiles, mix the colors, or leave it plain." },
  { model: "pendant-1x3-bail.stl",         kind: "pendant", name: "Pendant · 1x3",        price: "$29",
    desc: "A closed-bail pendant that hangs on any chain, carrying three studs on the face — stack a run of tiles, mix the colors, or leave it plain." },
  { model: "pendant-2x2-bail.stl",         kind: "pendant", name: "Pendant · 2x2",        price: "$29",
    desc: "A closed-bail pendant that hangs on any chain, with a full four-stud face — the widest canvas in the range, and the boldest one to stack." },
];

const deckEl = document.querySelector(".deck");
const heroCard = deckEl.querySelector(".citem");
DECK.forEach((pr, n) => {
  const c = heroCard.cloneNode(true);              // literally the same card, re-filled
  c.removeAttribute("data-hero");
  c.dataset.model = pr.model;
  c.dataset.kind = pr.kind;
  c.querySelector(".card-id").textContent = "#" + String(n + 2).padStart(2, "0");
  c.querySelector(".p-name").textContent = pr.name;
  c.querySelector(".p-price").textContent = pr.price;
  c.querySelector(".p-desc").textContent = pr.desc;
  deckEl.appendChild(c);
});

// ---- STUDIO: a WORKSPACE, not a grid (Tom 08-09).
// One piece on the bench in the middle, the whole range as thumbnails down the
// right. Pick the piece, pick the finish, click the tiles on. Both the bench
// card and the thumbnails are clones of the product card, so the chrome is
// identical — radius, outline, background, product render, name. The bench card
// is the only one carrying controls: the .sw / .tsw handlers below bind to it
// with no new wiring, and a REMOVE chip clears the tiles so a combo can be built
// up and torn down.
const ST_ALL = [{ model: heroCard.dataset.model, kind: "stud", name: "Stud Earring" }, ...DECK];
const stBench = document.querySelector(".st-bench");
const stRail = document.querySelector(".st-rail");

function studioCard(pr, opts) {
  const c = heroCard.cloneNode(true);
  c.removeAttribute("data-hero");
  c.dataset.model = pr.model;
  c.dataset.kind = pr.kind;
  c.dataset.studio = "1";
  c.querySelector(".card-id").remove();
  c.querySelectorAll(".card-side").forEach((n) => n.remove());
  c.querySelector(".p-price").remove();
  c.querySelector(".p-desc").remove();
  c.querySelector(".buy-row").remove();
  const nm = c.querySelector(".p-name");
  nm.classList.add("st-name");
  nm.textContent = opts.short || pr.name;
  if (opts.controls) {
    // The bench splits in two: every control lives in a column down the left,
    // one numbered step at a time, and the piece gets the rest of the card to
    // stand in. (Tom 08-09: "put everything on the left side like 1/3 of the
    // work space... and put the instructions as the header for each step")
    const finishes = c.querySelector(".p-colors");
    const tiles = document.createElement("div");
    tiles.className = "p-colors st-tilecolors";
    finishes.querySelectorAll(".tsw").forEach((s) => s.remove());   // the real LEGO range replaces the four
    LEGO_PALETTE.forEach(([name, hex]) => {
      const s = document.createElement("span");
      s.className = "tsw";
      s.dataset.hex = String(hex);
      s.title = name;
      s.style.background = plasticSwatch(hex);
      tiles.appendChild(s);
    });

    const custom = document.createElement("button");
    custom.type = "button";
    custom.className = "tsw tsw-custom";
    custom.title = "Custom color";
    tiles.appendChild(custom);
    const rm = document.createElement("span");
    rm.className = "tsw tsw-none";
    rm.title = "Take the tiles off";
    tiles.appendChild(rm);

    // one chip per stud — round, the same chip as the colors beside them. Every
    // piece shows this step, so a 1x1 simply has one circle and all twelve read
    // the same way. (Tom 08-09)
    const slots = document.createElement("div");
    slots.className = "st-slots";

    const panel = document.createElement("div");
    panel.className = "st-panel";
    panel.append(nm, step("01", "Pick a style"), finishes,
                 step("02", "Pick a tile", "st-step-slots"), slots,
                 step("03", "Pick a color"), tiles,
                 hints());

    const stage = document.createElement("div");
    stage.className = "st-stage";

    c.querySelector(".card-under").remove();
    c.append(panel, stage);
  } else {
    c.querySelector(".p-colors").remove();          // thumbnail = render + name only
  }
  return c;
}

function step(n, text, cls) {
  const p = document.createElement("p");
  p.className = "st-step" + (cls ? " " + cls : "");
  p.innerHTML = "<span>" + n + "</span> " + text;
  return p;
}
// One move per line, each with its own mark. Drawn as inline SVG rather than
// typed as glyphs so they render the same everywhere and match the page's 1px
// line language. (Tom 08-09)
const HINT_ICONS = {
  turn: '<path d="M2 6a4 4 0 1 1 1.2 2.85"/><path d="M2 2.6V6h3.4"/>',
  slide: '<path d="M6 1.6v8.8M1.6 6h8.8"/><path d="M6 1.6 4.4 3.4M6 1.6l1.6 1.8M6 10.4 4.4 8.6M6 10.4l1.6-1.8M1.6 6l1.8-1.6M1.6 6l1.8 1.6M10.4 6 8.6 4.4M10.4 6 8.6 7.6"/>',
  zoom: '<circle cx="5.2" cy="5.2" r="3.4"/><path d="M7.8 7.8 10.6 10.6M3.7 5.2h3M5.2 3.7v3"/>',
};
function hints() {
  const wrap = document.createElement("div");
  wrap.className = "st-hints";
  [["turn", "Drag to turn"], ["slide", "Shift-drag to slide"], ["zoom", "Scroll to zoom"]]
    .forEach(([k, text]) => {
      const p = document.createElement("p");
      p.className = "st-hint";
      p.innerHTML = '<svg viewBox="0 0 12 12" aria-hidden="true">' + HINT_ICONS[k] + "</svg><span></span>";
      p.querySelector("span").textContent = text;
      wrap.appendChild(p);
    });
  return wrap;
}

// Real LEGO colors, by their real names, so a combo built here is a combo that
// can actually be bought — BrickLink's most-used solid colors, five rows of
// six. (Tom 08-09: "actual lego colors not made up so they can buy it")
/* Every tile chip reads as PLASTIC — the same 135deg light-to-shade sweep the
   chrome and gold finish chips use in CSS, generated here so the studio's 34
   chips match the four hard-coded ones on the product cards exactly. (Tom 08-10) */
function plasticSwatch(hex) {
  const r = (hex >> 16) & 255, g = (hex >> 8) & 255, b = hex & 255;
  const mix = (t) => "rgb(" + [r, g, b].map((c) => Math.round(c + (255 - c) * t)).join(",") + ")";
  const dark = (t) => "rgb(" + [r, g, b].map((c) => Math.round(c * (1 - t))).join(",") + ")";
  /* a deeper ramp than the first pass — highlight, true colour, then a shaded
     edge, so the chip reads as a moulded plastic dome (Tom 08-10) */
  /* the shaded end was 26% down, which read as a much darker chip at phone size.
     12% keeps the moulded look without changing the colour you think you picked. */
  return "linear-gradient(135deg, " + mix(0.62) + " 0%, " + mix(0.22) + " 26%, #" +
    hex.toString(16).padStart(6, "0") + " 62%, " + dark(0.12) + " 100%)";
}

const LEGO_PALETTE = [
  ["Black", 0x05131d], ["White", 0xffffff], ["Light Bluish Gray", 0xafb5c7],
  /* Red / Blue / Yellow / Bright Green are pinned to the SAME hex the twelve
     product cards use (the LEGO constant above) — they were the muted real-LEGO
     values here and the vivid ones there, so the identical swatch produced two
     different tiles depending on which surface you were looking at. One source
     of truth; the cards win. (Tom 08-10) */
  ["Dark Bluish Gray", 0x6c6e68], ["Red", 0xff0000], ["Blue", 0x0000ff],

  ["Yellow", 0xffff00], ["Green", 0x237841], ["Bright Green", 0x4cbb17],
  ["Lime", 0xbbe90b], ["Orange", 0xfe8a18], ["Dark Orange", 0xa95500],

  ["Tan", 0xe4cd9e], ["Dark Tan", 0x958a73], ["Reddish Brown", 0x582a12],
  ["Brown", 0x583927], ["Purple", 0x81007b], ["Dark Purple", 0x3f3691],

  ["Medium Blue", 0x5a93db], ["Dark Blue", 0x0a3463], ["Dark Turquoise", 0x008f9b],
  ["Medium Azure", 0x36aebf], ["Sand Green", 0xa0bcac], ["Sand Blue", 0x6074a1],

  ["Dark Red", 0x720e0f], ["Magenta", 0x923978], ["Bright Pink", 0xe4adc8],
  ["Dark Pink", 0xc870a0], ["Light Aqua", 0xadc3c0], ["Yellowish Green", 0xdfeea5],

  ["Nougat", 0xd09168], ["Olive Green", 0x9b9a5a], ["Coral", 0xff698f],
  ["Dark Azure", 0x078bc9],
];

// Rail labels run on ONE line, so they are written short — the bench already
// spells the full name out above the controls. (Tom 08-09)
const ST_SHORT = {
  "stud-earring-1x1-square.stl": "Stud Square",
  "stud-earring-1x1-round.stl": "Stud Round",
  "click-hoop-1x1-square.stl": "Huggie Square",
  "click-hoop-1x1-round.stl": "Huggie Round",
  "click-hoop-1x2.stl": "Huggie 1x2",
  "click-hoop-1x3.stl": "Huggie 1x3",
  "click-hoop-2x2.stl": "Huggie 2x2",
  "pendant-1x1-round-bail.stl": "Pendant Round",
  "pendant-1x1-square-bail.stl": "Pendant Square",
  "pendant-1x2-bail.stl": "Pendant 1x2",
  "pendant-1x3-bail.stl": "Pendant 1x3",
  "pendant-2x2-bail.stl": "Pendant 2x2",
};

if (stBench && stRail) {
  stBench.appendChild(studioCard(ST_ALL[0], { controls: true }));
  ST_ALL.forEach((pr, i) => {
    const t = studioCard(pr, { controls: false, short: ST_SHORT[pr.model] });
    t.dataset.pick = String(i);
    if (i === 0) t.classList.add("on");
    stRail.appendChild(t);
  });
  // lenis owns the page wheel; without this the rail can't scroll and a zoom
  // gesture over the bench would scroll the page out from under the piece
  stBench.setAttribute("data-lenis-prevent", "");
  stRail.setAttribute("data-lenis-prevent", "");
}

// how many studs a piece carries — stated in its own filename, which is the same
// ground truth the tile seating reads
function cellsOf(model) {
  const m = /(\d)x(\d)/.exec(model || "");
  return m ? +m[1] * +m[2] : 1;
}
const deckCards = Array.from(deckEl.querySelectorAll(".citem"));

// #01's details slide into place first, before any other card arrives
const cardBits = [".p-head", ".p-colors", ".p-desc", ".buy-row"]
  .map((s) => heroCard.querySelector(s)).filter(Boolean);
gsap.set(cardBits, { y: 46, autoAlpha: 0 });
const cardTl = gsap.timeline({ paused: true });
cardTl.to(cardBits, { y: 0, autoAlpha: 1, stagger: 0.28, duration: 0.55, ease: "power2.out" }, 0.15);
/* DESKTOP ONLY. These cards are pre-hidden so the pinned fly-in can bring them
   in one at a time — but the phone build has no pin and updateDeck() returns
   early there, so nothing ever cleared this and cards #02-#12 stayed
   visibility:hidden forever. What you saw was card #01 with its chrome and then
   eleven bare 3D products floating on the page: the products are drawn in the
   shared WebGL canvas, so they kept rendering while their cards did not.
   (The code said the reveal was "owned by the per-card batch below" — there is
   no such batch in this file.) (Tom 08-11) */
/* true while the desktop fly-in has inline styles on the cards — the phone
   branch of updateDeck() uses it to clear up after a desktop -> phone resize
   exactly once, instead of fighting the per-card mobile reveal every tick */
let deckDesktopStyled = false;
if (window.innerWidth > 768) {
  deckCards.slice(1).forEach((el) => { el.style.opacity = "0"; el.style.visibility = "hidden"; });
  deckDesktopStyled = true;
}

let colStride = 340, rowStride = 616, deckBaseY = 0;
function measureDeck() {
  const a = deckCards[0], b = deckCards[1], d = deckCards[3];
  colStride = b.offsetLeft - a.offsetLeft;
  rowStride = d.offsetTop - a.offsetTop;
  deckBaseY = deckEl.offsetHeight / 2 - (a.offsetTop + a.offsetHeight / 2);   // row 1 centred
}
measureDeck();

const ASSEMBLY = 0.1;                       // first 10% of the pin = #01 assembling
const LAST = deckCards.length - 1;
function updateDeck(p) {
  /* MOBILE — the deck is a plain 2-up CSS grid on a phone, so the desktop
     fly-in (cards arriving one at a time into a wide row, the deck riding up
     as rows fill) has nothing to animate against: it just left eleven cards
     invisible. Show them all and leave the layout to CSS. (Tom 08-10) */
  if (window.innerWidth <= 768) {
    cardTl.progress(1);            // #01's assembly must land, or it shows empty
    deckEl.style.transform = "";
    /* THE PHONE GLITCH, ROOT CAUSE (Tom 08-11).
       This used to clear opacity / visibility / transform on all twelve cards on
       EVERY scroll tick of .scanner. But on a phone those three properties are
       owned by the per-card reveal ScrollTriggers at the bottom of this file —
       gsap.set(el,{opacity:0,y:46}) then a tween in. So two owners were writing
       the same properties: gsap faded a card in, the next scroll tick wiped the
       inline style off it, the card snapped to full opacity with no transform,
       gsap wrote it again. Measured at 390x844: the moment .scanner goes active,
       eight cards that had not entered yet went from opacity "0" to WIPED — i.e.
       fully visible, un-animated — and back. That flicker is the glitch.
       The clear existed only so a desktop -> phone RESIZE could recover from the
       desktop fly-in's inline styles, so it now runs ONCE, and only if the
       desktop path actually wrote anything. */
    if (deckDesktopStyled) {
      deckDesktopStyled = false;
      deckCards.forEach((el) => {
        el.style.opacity = "";
        el.style.visibility = "";
        el.style.transform = "";
      });
    }
    return;
  }
  deckDesktopStyled = true;
  cardTl.progress(Math.min(1, p / ASSEMBLY));
  const s = Math.min(1, Math.max(0, (p - ASSEMBLY) / (1 - ASSEMBLY)));
  const cur = s * LAST;                     // index of the card currently arriving
  deckCards.forEach((el, i) => {
    const t = Math.min(1, Math.max(0, cur - i + 1));    // 0 = not here yet, 1 = seated
    const e = t * t * (3 - 2 * t);
    // #01 sits in the CENTRE column until #02 arrives, then slides into its own slot
    const x = i === 0 ? (1 - Math.min(1, Math.max(0, cur))) * colStride : 0;
    el.style.transform = `translate3d(${x}px, ${(1 - e) * 70}px, 0) scale(${0.94 + 0.06 * e})`;
    if (i > 0) {
      el.style.opacity = e;
      el.style.visibility = e > 0.002 ? "visible" : "hidden";
    }
    const piece = deckPieceOf.get(el);
    if (piece) piece.pop = e;
  });
  const row = Math.min(3, Math.max(0, (cur - 2) / 3));  // deck rides up as rows fill
  deckEl.style.transform = `translate3d(0, ${deckBaseY - row * rowStride}px, 0)`;
}
updateDeck(0);

/* The hero and the card products are drawn at different sizes: the hero at its
   seated world scale, a card product at productPx(cardRect). This returns the
   hero scale that renders at the SAME on-screen size as card #01's product, so
   the hand-off is a match rather than a jump-cut. (Tom 08-10) */
function heroHandoffScale() {
  const card = document.querySelector(".scanner .citem");
  if (!card || !heroCan) return heroCan ? heroCan.userData.scale : 1;
  const r = card.getBoundingClientRect();
  const hp = heroPx();
  if (!hp) return heroCan.userData.scale;
  return heroCan.userData.scale * (productPx(r) / hp);
}

/* WEB — THE HAND-OFF STARTS BEFORE THE PIN, NOT INSIDE IT (Tom 08-12: "make the
   main product scale smaller sooner because its still big, the both of them are
   touching").
   The shrink used to live in the pinned onUpdate, which cannot begin until
   .scanner's top has already reached the top of the screen — and by then card
   #01 has travelled up most of the viewport with the full-size main product
   still sitting over it, so the two overlap on the way in. Measured at
   1440x900: the card's top edge crosses the product's own silhouette while the
   pin progress is still 0.
   So the scale is driven by a scrubbed trigger over the approach instead: the
   product starts coming down as soon as .scanner shows its first sliver and is
   fully down to card-size — and switched off — while the card is still a third
   of a screen away. The pinned handler below now only has to keep it off.
   Phone is untouched: it has no pin and its own hide trigger lives at the
   bottom of this file. */
if (!MOB) {
  ScrollTrigger.create({
    trigger: ".scanner",
    start: "top 98%",
    end: "top 55%",
    scrub: true,
    onUpdate: (self) => {
      if (!heroCan) return;
      const s0 = heroCan.userData.scale;
      const k = heroHandoffScale();
      const t = self.progress;
      heroCan.scale.setScalar(s0 + (k - s0) * t);
      heroCan.visible = t < 0.995;
    },
    onLeaveBack: () => {
      if (!heroCan) return;
      heroCan.visible = true;
      heroCan.scale.setScalar(heroCan.userData.scale);
    },
  });
}

/* MOBILE: no pin. The deck is a plain 2-up grid on a phone, so pinning the
   section for six viewport heights bought nothing and made the page feel stuck
   — you had to scroll a long way before anything moved. The cards reveal
   themselves as they scroll into view instead (see the batch below). (Tom 08-10) */
/* (MOB is declared at the top of this file — every mobile branch shares it) */
ScrollTrigger.create({
  trigger: ".scanner",
  start: "top top",
  end: MOB ? "bottom top" : `+=${vh * 6}`,
  pin: !MOB,
  onUpdate: (self) => {
    updateDeck(self.progress);
    /* The shrink itself now happens BEFORE the pin (see the scrubbed trigger
       above) — by the time the section pins, the product is already down to
       card size and switched off. All this has to do is keep it off. */
    if (!MOB && heroCan && heroCan.visible) heroCan.visible = false;
  },
  onLeaveBack: () => {
    if (MOB || !heroCan) return;
    // hand back to the ONE main-product state — its own seated scale, nothing derived
    heroCan.visible = true;
    heroCan.scale.setScalar(heroCan.userData.scale);
  },
});

// (heroCardSpot is GONE with the .thinking rig — nothing derives the main
//  product's spot from the card any more. Tom 08-09)
// (the .thinking re-position/re-scale rig is GONE — the main product keeps the
//  click-screen spot and size straight through BOLD STACKING. Tom 08-09)

// captions reveal one by one as the hero scrolls (like the demo)
document.querySelectorAll(".captions p").forEach((el, i) => {
  gsap.set(el, { opacity: 0 });
  gsap.to(el, {
    opacity: el.classList.contains("ghost") ? 0.35 : 1,
    scrollTrigger: { trigger: ".hero", start: `${8 + i * 10}% top`, end: `${20 + i * 10}% top`, scrub: true },
  });
});


// left-margin texts parallax with the scroll (different depths)
gsap.to(".edge-left-big p", {
  yPercent: -22,
  ease: "none",
  scrollTrigger: { trigger: "body", start: "top top", end: "bottom bottom", scrub: true },
});
gsap.to(".edge-left-marquee p", {
  yPercent: -140,
  ease: "none",
  scrollTrigger: { trigger: "body", start: "top top", end: "bottom bottom", scrub: true },
});

// sporadic tinted letters — lifted verbatim from the-click page
(function () {
  'use strict';
  var CYCLE = ['blue', 'yellow', 'red', '#4CBB17'];
  var n = 0;
  var SKIP = /^(SCRIPT|STYLE|NOSCRIPT|SVG|PATH|CANVAS|VIDEO|IMG|CODE|BUTTON)$/;

  // pd = the parent's display, read for EVERY node before any DOM write (walk below). Reading it here,
  // between writes, forced a full style recalc per text node: ~4s of main thread inside the theme (Tom 10-15).
  function tintNode(node, pd) {
    var txt = node.nodeValue;
    if (!txt || !txt.trim()) return;
    if (pd === 'flex' || pd === 'inline-flex' || pd === 'grid' || pd === 'inline-grid') {
      var holder = document.createElement('span');
      node.parentNode.replaceChild(holder, node);
      holder.appendChild(node);
    }
    // ONLY 4-letter words get color — every letter, always the same
    // blue-yellow-red-green order (Tom 08-07)
    var parts = txt.split(/(\s+)/);
    var any = false;
    var frag = document.createDocumentFragment();
    parts.forEach(function (w) {
      var core = w.replace(/[^A-Za-z0-9]/g, '');
      if (core.length === 4 && /^[A-Za-z0-9]+$/.test(core)) {
        any = true;
        var k = 0;
        for (var i = 0; i < w.length; i++) {
          var ch = w[i];
          if (/[A-Za-z0-9]/.test(ch)) {
            var el = document.createElement('i');
            el.className = 'tk';
            el.style.color = CYCLE[k % 4];
            el.textContent = ch;
            frag.appendChild(el);
            k++;
          } else {
            frag.appendChild(document.createTextNode(ch));
          }
        }
      } else {
        frag.appendChild(document.createTextNode(w));
      }
    });
    if (!any) return;
    node.parentNode.replaceChild(frag, node);
  }

  function walk(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (nd) {
        var p = nd.parentNode;
        if (!p || SKIP.test(p.nodeName)) return NodeFilter.FILTER_REJECT;
        if (p.classList && p.classList.contains('tk')) return NodeFilter.FILTER_REJECT;
        return nd.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var list = [], nd;
    while ((nd = w.nextNode())) list.push(nd);
    var pds = list.map(function (t) { return getComputedStyle(t.parentNode).display; });
    list.forEach(function (t, i) { tintNode(t, pds[i]); });
  }
  function run() { walk(document.body); }
  if (document.readyState === 'complete') setTimeout(run, 60);
  else window.addEventListener('load', function () { setTimeout(run, 60); });
})();

/* scrollY comes from Lenis on desktop and from the window on a phone, where
   Lenis does not exist. Without this branch the page threw on every mobile load
   and nothing that depended on scroll ever ran. (Tom 08-11) */
if (lenis) {
  lenis.on("scroll", (e) => { scrollY = e.scroll; });
} else {
  const syncY = () => { scrollY = window.scrollY || window.pageYOffset || 0; };
  syncY();
  window.addEventListener("scroll", syncY, { passive: true });
}

// ---- THE COLLECTION: every product in a 3-per-row grid; each piece tracks its
// DOM cell (canvas is fixed, cells scroll) and pops in as its row arrives ----
// Every card product is drawn at the SAME size the stud holds on the click
// screen, so nothing ever resizes on the way into a card (Tom 08-08).
// Capped so a tall piece can't outgrow its card on a very tall window.
function heroPx() {
  const wpp = (2 * (camera.position.z - SPREAD[0][2]) * Math.tan((camera.fov * Math.PI) / 360)) / VH;
  return (SPREAD[0][3] * 1.2) / wpp;            // px the hero renders at its natural scale
}
/* the card's WIDTH caps the piece too, not just its height — without this the
   render came out as wide as the card itself and touched both borders, so
   "centred" still read as cramped. 0.80 leaves even margin either side. (Tom 08-10) */
function productPx(rect) { return Math.min(heroPx(), rect.height * 0.56, rect.width * 0.62); }

const COLLECTION_KIND = {
  stud:    { pose: [0.82, 0.42, 0.78],     rock: 0.28 },
  hoop:    { pose: [0.12, Math.PI / 2, 0], sway: true },
  pendant: { pose: [0.12, Math.PI, 0],     sway: true },
  tile:    { pose: [0.65, 0.4, 0],         spin: true },
};
// One parse per model file, shared by every card that shows it. The deck, the
// rail and the bench all ask for the same twelve STLs — the pendants alone are
// 8MB each, so parsing them once instead of once per card is the difference
// between a page that swaps pieces instantly and one that refetches. Sharing a
// BufferGeometry between meshes is free in three.js. (Tom 08-09)
/* loadGeo + geoCache now live next to parseSTL, above the hero fleet, because
   the fleet loads through the same cache (it used to fetch independently,
   which is why several models downloaded twice). (Tom 08-10) */

const collPieces = [];
window.__collPieces = collPieces;   // QC handle, like window.__benchView below
/* RAIL THUMBNAILS USE THE LIGHT MESH. The studio rail draws every piece at ~80px,
   and a pendant is 170k triangles: the rail alone was ~875k triangles a frame for
   pictures the size of a stamp. The lite-*.glb copies (pendants 24k, huggies and
   studs 16k) are indistinguishable at that size; the bench and the deck cards,
   which render big, keep the full mesh. A missing lite file falls back to full. (Tom 10-15) */
const LITE = /^(pendant-|click-hoop-|stud-earring-)/;
const geoFor = (cell) => (cell.closest(".st-rail") && LITE.test(cell.dataset.model))
  ? loadGeo("lite-" + cell.dataset.model).catch(() => loadGeo(cell.dataset.model))
  : loadGeo(cell.dataset.model);
document.querySelectorAll(".citem").forEach((cell, ci) => {
  const kind = COLLECTION_KIND[cell.dataset.kind];
  geoFor(cell)
    .then((g) => {
      const sz = g.boundingBox.getSize(new THREE.Vector3());
      const mesh = new THREE.Mesh(g, cell.dataset.plastic ? PLASTIC(parseInt(cell.dataset.plastic, 16)) : CHROME());
      mesh.rotation.x = -Math.PI / 2;
      mesh.scale.setScalar(1 / Math.max(sz.x, sz.y, sz.z));   // unit size — slot fill drives the wrap scale
      const pose = cell.dataset.pose ? cell.dataset.pose.split(",").map(Number) : kind.pose;
      const wrap = new THREE.Group();
      wrap.add(mesh);
      wrap.rotation.set(pose[0], pose[1], pose[2]);
      // Centre the POSED silhouette, not the raw geometry. The mesh is centred on
      // its own bounding box, but once the pose swings the post out to one side
      // the visible mass sits off-centre — the studs read as pushed left in their
      // card. Re-centre on the bounds after posing. (Tom 08-09)
      wrap.updateMatrixWorld(true);
      const pb = new THREE.Box3().setFromObject(wrap).getCenter(new THREE.Vector3());
      mesh.position.sub(pb.applyQuaternion(wrap.quaternion.clone().invert()));
      wrap.visible = false;
      deckScene.add(wrap);
      const amp = cell.dataset.pose ? 0.22 : (kind.sway ? 0.6 : kind.rock || 0.25);   // flat face-on pieces only rock gently
      // STL units are millimetres (verified: 12.00mm post, 13mm hoop OD) — every
      // product is drawn at the SAME mm-per-pixel so the grid is true to scale
      // geo + unit are kept so a click-on tile can be seated on this product's
      // own brick face later, at the same mm-per-unit as the product (Tom 08-09)
      // A click-on tile is a SIBLING of the mesh inside the wrap, so it has to
      // carry the same local offset the re-centring above just gave the mesh —
      // otherwise every tile lands beside its plate by exactly that shift, which
      // is what put the tile off the face on all twelve products. (Tom 08-09)
      const piece = { wrap, mesh, cell, kind, pose, amp, mats: [mesh.material], phase: ci * 0.9, pop: 0,
                      geo: g, unit: 1 / Math.max(sz.x, sz.y, sz.z), tiles: null,
                      meshOffset: mesh.position.clone() };
      collPieces.push(piece);
      deckPieceOf.set(cell, piece);   // updateDeck drives its pop from the card sequence
    })
    .catch((e) => console.error("collection model failed:", cell.dataset.model, e));
});

// Put a different product on an existing piece: swap the geometry, re-derive
// everything that depends on it (unit scale, pose, silhouette re-centring) and
// drop any tiles, since a tile is seated against the geometry it was built for.
// This is what lets the studio bench become any of the twelve without a second
// set of 3D objects — one bench piece, twelve models. (Tom 08-09)
function setPieceModel(piece, model, kind) {
  return loadGeo(model).then((g) => {
    const sz = g.boundingBox.getSize(new THREE.Vector3());
    if (piece.tiles) { piece.tiles.forEach((t) => { gsap.killTweensOf(t.position); if (t.parent) t.parent.remove(t); }); piece.tiles = null; }
    piece.mesh.geometry = g;
    piece.mesh.position.set(0, 0, 0);
    piece.mesh.scale.setScalar(1 / Math.max(sz.x, sz.y, sz.z));
    piece.kind = kind;
    piece.pose = kind.pose;
    piece.amp = kind.sway ? 0.6 : kind.rock || 0.25;
    piece.wrap.rotation.set(kind.pose[0], kind.pose[1], kind.pose[2]);
    // Re-centre the posed silhouette exactly as the loader does — which means
    // measuring the wrap UNTRANSFORMED. By now the layout has already given this
    // wrap its on-screen position and a scale in the hundreds, and measuring
    // through that turns the offset into a world-space number that threw the
    // piece tens of thousands of units off screen. (Tom 08-09)
    const keepPos = piece.wrap.position.clone(), keepScale = piece.wrap.scale.clone();
    piece.wrap.position.set(0, 0, 0);
    piece.wrap.scale.set(1, 1, 1);
    piece.wrap.updateMatrixWorld(true);
    const pb = new THREE.Box3().setFromObject(piece.wrap).getCenter(new THREE.Vector3());
    piece.mesh.position.sub(pb.applyQuaternion(piece.wrap.quaternion.clone().invert()));
    piece.wrap.position.copy(keepPos);
    piece.wrap.scale.copy(keepScale);
    piece.wrap.updateMatrixWorld(true);
    piece.geo = g;
    piece.unit = 1 / Math.max(sz.x, sz.y, sz.z);
    piece.meshOffset = piece.mesh.position.clone();
  });
}

window.__collPieces = collPieces;   // QC handle

// Cards are laid out in PIXELS against the ortho deck camera — no unproject, no
// perspective, so a product in the left column looks exactly like the same
// product in the middle. (Tom 08-08: "no fish eye, display them as they are")
/* THE BAND: the strip of a card the product actually owns — under the #01
   label, above the content block (or, in a rail thumbnail, above its name).
   Cached per piece and only re-measured when the layout can have changed
   (bandGen is bumped by the resize handler), because these are card-relative
   offsets: the deck's fly-in translates a whole card, which moves the label and
   the content block by the same amount, so the band inside it never moves.
   Measuring three rects per card per frame — 36 extra layout reads at 60fps on a
   phone — was real work for an answer that only changes on resize. (Tom 08-12) */
/* SCRATCH OBJECTS — updateCollection runs on EVERY animation frame, for every
   product on screen, and it used to allocate a fresh THREE.Vector3 for each of a
   piece's eight box corners plus a THREE.Box3 and another Vector3 for the
   centring correction. Measured on a phone viewport: 89 Vector3 + 9 Box3 per
   frame in the studio and 54 + 6 in the card grid — about 5,300 allocations a
   second, all of it garbage. The collector then pauses the main thread mid-
   scroll, and a pause in the frame that places the products against their cards
   is exactly what reads as the jewelry juddering. These are reused instead, so
   the steady-state allocation in the render loop is zero. (Tom 08-12/13: "the
   glitchyness as i scroll in the last two sections is still there") */
const _v = new THREE.Vector3();
const _box = new THREE.Box3();
const _ctr = new THREE.Vector3();

let bandGen = 0;
function cardBand(p, rect, rail) {
  if (p._bandGen === bandGen && p._band) return p._band;
  const idEl = p.cell.querySelector(".card-id");
  const underEl = p.cell.querySelector(".card-under");
  const labelEl = p.cell.querySelector(".p-name");
  const top = idEl ? idEl.getBoundingClientRect().bottom - rect.top : 0;
  const endEl = rail ? labelEl : underEl;
  const bot = endEl ? endEl.getBoundingClientRect().top - rect.top : rect.height;
  const band = bot > top
    ? { h: bot - top, frac: (top + bot) / 2 / rect.height }
    : { h: rect.height, frac: rail ? 0.42 : 0.40 };
  p._band = band;
  p._bandGen = bandGen;
  return band;
}

function updateCollection(t) {
  if (!collPieces.length) return;
  const W = VW, H = VH;
  collPieces.forEach((p) => {
    // studio cards are always "arrived" — only the deck ones pop in on scroll
    if (p.cell.dataset.studio) p.pop = 1;
    let rect = p.cell.getBoundingClientRect();
    let on = rect.bottom > -40 && rect.top < H + 40;
    // The rail scrolls inside itself, but the 3D canvas is fixed and full-screen,
    // so a thumbnail scrolled past the rail's edge would still have its product
    // drawn floating over the page. Clip to the rail. (Tom 08-09)
    const clip = p.cell.parentElement && p.cell.parentElement.classList.contains("st-rail")
      ? p.cell.parentElement.getBoundingClientRect() : null;
    // A thumbnail only shows its product while the whole card is inside the rail.
    // Hiding on the first pixel of overlap blanked the card sitting flush against
    // the top edge; hiding only once the card is fully gone left the product of a
    // half-scrolled card floating over the page above the rail. (Tom 08-09)
    if (clip && (rect.top < clip.top - 2 || rect.bottom > clip.bottom + 2)) on = false;
    p.wrap.visible = on && p.pop > 0.001;
    if (!on) return;
    const bench = p.cell.parentElement && p.cell.parentElement.classList.contains("st-bench");
    const rail = !!clip;
    // on the bench the piece belongs to the STAGE, not the whole card — the
    // controls own the left third and the piece must centre in what is left
    if (bench) {
      const st = p.cell.querySelector(".st-stage");
      if (st) rect = st.getBoundingClientRect();
    }
    // How big the piece can get on the bench: the stage, less a small margin,
    // measured against the piece's own bounding SPHERE. A sphere is the one
    // measure that does not change as Tom turns the piece, so a shape that fits
    // head-on cannot swing out through the edge a moment later — which a
    // box-based fit allows. (Tom 08-10: "has to stay inside of the workspace
    // area not go past it either")
    let benchFit = 0, benchR = 0, benchCx = 0, benchCy = 0;
    if (bench) {
      const g = p.mesh.geometry;
      if (!g.boundingSphere) g.computeBoundingSphere();
      if (MOB) {
        /* PHONE ONLY — the piece fills the workspace, and every one of the
           twelve fills it by the SAME amount. (Tom 08-11)
           The desktop formula below bounds a sphere drawn about the WRAP ORIGIN,
           so it pays for the piece's own off-centre-ness twice: once in
           |sphere.center| and again in |meshOffset|. Those two are large and
           different per model — a bailed pendant carries far more of both than a
           stud does — which is exactly why some pieces rendered small and the
           stud did not. Here the fit is against the piece's OWN sphere (the true
           radius, still rotation-invariant so nothing can swing out through the
           border), and the wrap is then shifted so that sphere's centre lands on
           the middle of the stage. The drawn extent is therefore benchR either
           side of the stage centre for all twelve. With the padding gone the
           margin can also come back up: 0.74 -> 0.92 of the stage. */
        benchR = g.boundingSphere.radius * p.unit;
        const c = _ctr.copy(g.boundingSphere.center)
          .applyQuaternion(p.mesh.quaternion)
          .multiplyScalar(p.mesh.scale.x)
          .add(p.meshOffset)
          .applyQuaternion(p.wrap.quaternion);
        benchCx = -c.x; benchCy = -c.y;          // scaled by pxNow below
        /* FIT THE SILHOUETTE, NOT THE SPHERE — and fit it to BOTH axes of the
           stage rather than to whichever is smaller.
           A sphere is as wide as the piece is long, so on a phone's tall narrow
           stage (252 x 521) `min(w,h)` fitted every piece into the 252 WIDTH and
           left the height empty: measured, the twelve filled only 29-44% of it.
           A bailed pendant is long and thin — its sphere wastes almost all of the
           room it has. So measure the piece's own posed bounding box, scale until
           the binding axis is full, and let a tall piece grow until it fills the
           HEIGHT. Rotating can still swing a box past the edge; that is what the
           stage scissor is for now — it clips rather than escaping, which is the
           safe direction and the reason a box fit is affordable here at all.
           (Tom 08-12: "make the 3d product bigger to fit the height of the
           workspace. do it for all of them.") */
        const bb0 = g.boundingBox || (g.computeBoundingBox(), g.boundingBox);
        let hx = 0, hy = 0;
        for (let i = 0; i < 8; i++) {
          const v = _v.set(
            i & 1 ? bb0.max.x : bb0.min.x,
            i & 2 ? bb0.max.y : bb0.min.y,
            i & 4 ? bb0.max.z : bb0.min.z
          ).applyQuaternion(p.mesh.quaternion).multiplyScalar(p.mesh.scale.x)
           .add(p.meshOffset).applyQuaternion(p.wrap.quaternion);
          hx = Math.max(hx, Math.abs(v.x - c.x));
          hy = Math.max(hy, Math.abs(v.y - c.y));
        }
        const K = 0.92;
        benchFit = Math.min(
          (rect.width  * K) / (2 * Math.max(hx, 1e-6)),
          (rect.height * K) / (2 * Math.max(hy, 1e-6))
        );
        // the pan clamp below measures with benchR; keep it honest to what is drawn
        benchR = Math.max(hx, hy);
      } else {
        // radius about the WRAP origin, not the geometry's own centre: the mesh
        // carries the posed re-centring offset, and ignoring it let the piece hang
        // ten pixels past the stage on both sides
        benchR = (g.boundingSphere.radius + g.boundingSphere.center.length()) * p.unit
               + p.meshOffset.length();
        benchFit = (Math.min(rect.width, rect.height) * 0.94) / (2 * benchR);
      }
    }
    let bx = bench ? benchView.px : 0, by = bench ? benchView.py : 0;
    if (bench) {
      // ...and the same sphere keeps a panned piece from sliding off the stage
      const half = benchR * Math.min(benchFit, benchFit * benchView.zoom);
      const roomX = Math.max(0, rect.width / 2 - half), roomY = Math.max(0, rect.height / 2 - half);
      bx = Math.max(-roomX, Math.min(roomX, bx));
      by = Math.max(-roomY, Math.min(roomY, by));
      benchView.px = bx; benchView.py = by;
    }
    /* THE BAND, MEASURED FIRST — it decides both how big the piece may be and
       where its centre goes, so it has to exist before pxNow. (Tom 08-12) */
    const band = bench ? null : cardBand(p, rect, rail);
    /* The posed silhouette's half-extents, in the piece's unit space. Recomputed
       every frame on purpose: the wrap's Y rotation is animated, so a piece is
       wider at some moments than others. Eight corners is cheap. */
    let ex = 0, ey = 0, ecx = 0, ecy = 0;
    if (!bench) {
      const g0 = p.mesh.geometry;
      if (!g0.boundingBox) g0.computeBoundingBox();
      const bb = g0.boundingBox, ms = p.mesh.scale.x;
      let lo = Infinity, hi = -Infinity, lo2 = Infinity, hi2 = -Infinity;
      for (let i = 0; i < 8; i++) {
        const v = _v.set(
          i & 1 ? bb.max.x : bb.min.x,
          i & 2 ? bb.max.y : bb.min.y,
          i & 4 ? bb.max.z : bb.min.z
        ).applyQuaternion(p.mesh.quaternion).multiplyScalar(ms)
         .add(p.meshOffset).applyQuaternion(p.wrap.quaternion);
        if (v.x < lo) lo = v.x; if (v.x > hi) hi = v.x;
        if (v.y < lo2) lo2 = v.y; if (v.y > hi2) hi2 = v.y;
      }
      ex = Math.max(hi - lo, 1e-6); ey = Math.max(hi2 - lo2, 1e-6);
      ecx = (lo + hi) / 2; ecy = (lo2 + hi2) / 2;
    }
    /* ...and the piece is then held INSIDE that band. Measured before this
       change at 1440x900, card #11's pendant stood 166.8px tall in a 323px band
       but was pinned at a fixed 0.40 of the card, so it hung 67px down THROUGH
       the band's bottom edge into the name and price. A card product now never
       draws outside the room it has, on either axis. (Tom 08-12: "center all of
       the 12 3d products in the card equally in the space so there is equal
       space all around the product") */
    const FIT = 0.88;
    const pxNow = bench ? benchFit * Math.min(1, benchView.zoom)
                : rail ? Math.min(rect.height * 0.44, rect.width * 0.50,
                                  (band.h * FIT) / ey, (rect.width * FIT) / ex)
                : Math.min(productPx(rect), (band.h * FIT) / ey, (rect.width * FIT) / ex);
    /* Centre the PIECE on the card, not the wrap. The mesh sits at meshOffset
       inside the wrap and the geometry's own centre is offset again, and then
       the WRAP is rotated by the pose — so the on-screen displacement is that
       combined offset run through the wrap's rotation. Compensating with the
       raw meshOffset.x (the first attempt) only fixed part of it and the piece
       still sat left. Rotate it first, then cancel both axes. Bench is
       excluded: it has its own sphere fit and pan clamping. (Tom 08-10) */
    let cx = 0, cy = 0;
    /* phone bench: put the piece's own bounding-sphere centre on the middle of
       the stage, which is what the 0.92 fit above is measured against */
    if (bench && MOB) {
      const s = pxNow * p.pop;
      cx = benchCx * s; cy = benchCy * s;
    }
    if (!bench) {
      // Exact visual centre: the 8-corner box measured above (in unit space) is
      // the posed silhouette, so cancelling its centre puts the SHAPE on the
      // target point. The bounding SPHERE centre is not the visual centre of an
      // asymmetric piece — a stud is a wide plate plus a thin post, so the plate
      // kept hanging past the card's left edge.
      const s = pxNow * p.pop;
      cx = -ecx * s;
      cy = -ecy * s;
    }
    /* WHERE THE PIECE SITS VERTICALLY IN A DECK CARD.
       It used to be a fixed fraction of the card's height (0.40), which only
       worked at the one card height that fraction was tuned against — shorten the
       card and the piece keeps sliding down into the name and price. Measure the
       band the piece actually has instead: below the #01 label, above the content
       block. Then it is centred in its own space at any card height. Bench and
       rail keep their own fractions; they have no content block under them. */
    /* WHERE THE PIECE SITS VERTICALLY — the middle of its band, on every width.
       This used to be a fixed 0.40 of the card height on the web build (0.42 in
       the rail), a constant tuned against one card height, so the space above
       and below the product was never equal: measured at 1440x900, card #02 sat
       with 147px of air above it and 76 below. Phone already measured its band;
       web now does the same, so one rule covers both. (Tom 08-12) */
    const deckFrac = bench ? 0.50 : band.frac;
    p.wrap.position.set(
      rect.left + rect.width / 2 - W / 2 + bx + cx,
      H / 2 - (rect.top + rect.height * (bench ? 0.50 : deckFrac)) + by + cy,
      0
    );
    // The bench is the whole point of the studio — the piece stands there at room
    // to be looked at, not at the little card size the grid used. Sized off the
    // sway's WIDEST reading, not the resting one: a huggie's ring swings from
    // edge-on to face-on, and at face-on the taller silhouette was climbing out
    // through the top of the card. (Tom 08-09)
    // three to a row means a thumbnail is wider than it is tall — size the render
    // off the card's HEIGHT so the piece clears the name and both card edges
    // the bench fills its stage; zoom may pull the piece IN but never past the
    // edge, so the workspace always holds the whole product
    const px = pxNow;
    p.wrap.scale.setScalar(px * p.pop);

    /* Final centring correction, measured off the REAL object. The maths above
       only knows the base mesh, so card #01 — the one the tiles click onto —
       still sat ~14px left once a tile was on it. Measuring the wrap's actual
       world box after it is positioned and scaled catches the tiles and any
       pose, and self-corrects each frame. Bench excluded (it owns its own fit
       and pan clamping — a fit change here made the piece vanish once). (Tom 08-10) */
    if (!bench && p.pop > 0.01) {
      p.wrap.updateMatrixWorld(true);
      const wb = _box.setFromObject(p.wrap);
      if (isFinite(wb.min.x)) {
        const wc = wb.getCenter(_ctr);
        p.wrap.position.x += p.wrap.position.x - wc.x;
        p.wrap.position.y += p.wrap.position.y - wc.y;
      }
    }
    if (bench && benchView.touched) {              // Tom is driving it — hold where he put it
      p.wrap.rotation.x = p.pose[0] + benchView.rx;
      p.wrap.rotation.y = p.pose[1] + benchView.ry;
      p.wrap.rotation.z = p.pose[2];
    } else if (bench) {
      /* RESET VIEW HAS TO PUT THE TILT BACK TOO. Only the touched branch above
         ever wrote rotation.x, so when RESET set rx to 0 and touched to false in
         the same breath, the next frame took this branch and rotation.x simply
         kept whatever angle the piece had been dragged to — the piece went back
         to its starting size and position and stayed tipped over. It is written
         here as well now, so releasing control genuinely returns the pose.
         (Tom 08-12: "the reset view doesnt reset it to its orginial position") */
      p.wrap.rotation.x = p.pose[0];
      p.wrap.rotation.z = p.pose[2];
      p.wrap.rotation.y = p.kind.spin ? p.pose[1] + t * 0.5
        : p.pose[1] + Math.sin(t * (p.kind.sway ? 0.8 : 0.6) + p.phase) * p.amp;
    } else if (p.kind.spin) p.wrap.rotation.y = p.pose[1] + t * 0.5;
    else p.wrap.rotation.y = p.pose[1] + Math.sin(t * (p.kind.sway ? 0.8 : 0.6) + p.phase) * p.amp;
  });
}

// ---- click-on tiles for the CARD products (Tom 08-09) ----
// One generic seat: the brick face is always the face the product is posed to
// show the camera, so we find the frontmost plateau along that direction and
// land the tile on it. Works for studs, huggies and pendants without a
// per-model table. Round products get the round tile.
const QX = new THREE.Quaternion().setFromEuler(new THREE.Euler(-Math.PI / 2, 0, 0));

// Find the brick face AND every stud cell on it, in the product's own STL space.
// These models are axis-aligned, so the face normal is snapped to a principal
// axis — that keeps the tile's edges parallel to the plate's instead of landing
// at a random roll — and the stud bumps give the exact cell centres to sit on,
// so a 1x2 / 1x3 / 2x2 face gets a tile per stud instead of one straddling it.
// (Tom 08-09: "fit it so the tile is on the stud correctly, all 12 products")
function faceCells(piece) {
  const qPose = new THREE.Quaternion().setFromEuler(
    new THREE.Euler(piece.pose[0], piece.pose[1], piece.pose[2], "XYZ"));
  const dirWrap = new THREE.Vector3(0, 0, 1).applyQuaternion(qPose.clone().invert());

  // The brick face is a property of the MODEL, not of the camera: it is the one
  // principal face that has a big flat plateau with stud bumps standing proud of
  // it. Deriving it from the pose picked the wrong axis on a 3/4-posed stud and
  // dropped the tile beside the plate at a 45deg roll. (Tom 08-09)
  const pos = piece.geo.attributes.position;

  // The face is the one the piece is POSED to show — every product's pose points
  // its brick face at the camera. What was wrong before was the ROLL (the tile
  // landed as a diamond) and the CENTRING (the stud bumps dragged the centroid
  // off the plate), so both of those are now derived from the model's own axes.
  // ...snapped to the nearest model axis, because these are machined parts: the
  // face is a true principal plane, so the tile's edges land parallel to the
  // plate's instead of at whatever roll the camera happens to be at.
  // Score the six principal faces by the AREA of flat surface pointing that way,
  // not by vertex count. On a machined STL a flat plate is two big triangles (~6
  // verts) while a stud bump or a hoop is hundreds, so counting vertices picked
  // the bumps every time — wrong axis, wrong centre, and the cell grid collapsed
  // to 1. Area is what "biggest flat face" actually means. (Tom 08-09)
  const dm = dirWrap.clone().applyQuaternion(QX.clone().invert());
  const AXES = [
    new THREE.Vector3(1, 0, 0), new THREE.Vector3(-1, 0, 0),
    new THREE.Vector3(0, 1, 0), new THREE.Vector3(0, -1, 0),
    new THREE.Vector3(0, 0, 1), new THREE.Vector3(0, 0, -1),
  ];
  const a = new THREE.Vector3(), bV = new THREE.Vector3(), cV = new THREE.Vector3();
  const ab = new THREE.Vector3(), ac = new THREE.Vector3(), nrm = new THREE.Vector3();
  const tri = [];                                  // {area, n, cen} per triangle, once
  for (let i = 0; i < pos.count; i += 3) {
    a.fromBufferAttribute(pos, i); bV.fromBufferAttribute(pos, i + 1); cV.fromBufferAttribute(pos, i + 2);
    ab.subVectors(bV, a); ac.subVectors(cV, a);
    nrm.crossVectors(ab, ac);
    const area = nrm.length() * 0.5;
    if (area < 1e-6) continue;
    tri.push({ area, n: nrm.clone().normalize(),
               cen: new THREE.Vector3((a.x + bV.x + cV.x) / 3, (a.y + bV.y + cV.y) / 3, (a.z + bV.z + cV.z) / 3) });
  }
  // WHICH face: the one the pose shows. Every product is posed to present its
  // brick face at the camera, so snapping the view direction to the nearest
  // model axis names it directly. Scoring all six faces by area instead picked
  // side walls — the 1x2 and 1x3 drops seated their tiles on the plate's right
  // EDGE, and the 1x1 round put one on the hoop ring. (Tom 08-09)
  let e = null;
  { let bestDot = -Infinity;
    AXES.forEach((cand) => { const dp = cand.dot(dm); if (dp > bestDot) { bestDot = dp; e = cand.clone(); } }); }
  if (!e) e = new THREE.Vector3(0, 0, 1);

  const p1 = Math.abs(e.x) > 0.5 ? new THREE.Vector3(0, 1, 0) : new THREE.Vector3(1, 0, 0);
  const p2 = new THREE.Vector3().crossVectors(e, p1);

  // The stud grid is stated in the model's own filename — click-hoop-1x2 has two
  // cells, pendant-2x2 has four. Measuring it off the mesh was guesswork that
  // collapsed every product to a single cell; the name is ground truth. (Tom 08-09)
  const grid = /(\d)x(\d)/.exec(piece.cell.dataset.model || "");
  const gA = grid ? +grid[1] : 1, gB = grid ? +grid[2] : 1;
  const PITCH = 8;
  const long = Math.max(gA, gB), short = Math.min(gA, gB);

  // WHICH patch of that plane is the plate. A hoop's ring and a pendant's bail
  // lie in the SAME plane as the plate, and the ring is the bigger lump — so
  // "densest patch" and "most area" both chose the ring, and the run of tiles
  // floated off the end of the drop. Label every connected patch and pick the
  // one whose FOOTPRINT matches the grid the filename declares: a 1x3 drop
  // measures 24x8mm where the ring measures about 12x12. Size identifies the
  // plate; area never could. (Tom 08-09)
  // ...and WHICH DEPTH. Picking the depth first was the whole bug: on a huggie
  // the ring's side is the outermost surface and the drop plate sits deeper than
  // any "outer shell" band reaches, so faceD landed on a 2x5mm sliver of hinge
  // and every later fix was refining the wrong plane. Search depth and footprint
  // TOGETHER — over every flat plane facing this way, take the patch whose
  // measured footprint best matches the grid the filename declares. The plate is
  // the only thing on the model that is 8/16/24mm on the brick pitch. (Tom 08-09)
  const G = 2, wantLong = long * PITCH, wantShort = short * PITCH;
  const flat = tri.filter((t) => t.n.dot(e) >= 0.9);
  const depths = [...new Set(flat.map((t) => Math.round(t.cen.dot(e) * 2) / 2))].sort((x, y) => y - x);
  let faceD = 0, bestErr = Infinity, bestPts = null, nBlobs = 0;
  depths.forEach((dep) => {
    const face = [];
    flat.forEach((t) => {
      if (Math.abs(t.cen.dot(e) - dep) > 0.6) return;
      face.push({ u: t.cen.dot(p1), w: t.cen.dot(p2), area: t.area });
    });
    if (face.length < 2) return;
    const cellA = new Map();
    face.forEach((f) => {
      const k = Math.floor(f.u / G) + "," + Math.floor(f.w / G);
      cellA.set(k, (cellA.get(k) || 0) + f.area);
    });
    // Score the WHOLE plane at this depth, not one connected patch: the stud
    // bumps punch holes through the plate's flat top and split it into several
    // disconnected pieces, so no single patch ever spans the full 1x2 or 2x2
    // footprint. The union does. (Tom 08-09)
    nBlobs += cellA.size;
    let bu0 = Infinity, bu1 = -Infinity, bw0 = Infinity, bw1 = -Infinity;
    face.forEach((f) => {
      if (f.u < bu0) bu0 = f.u; if (f.u > bu1) bu1 = f.u;
      if (f.w < bw0) bw0 = f.w; if (f.w > bw1) bw1 = f.w;
    });
    const hi = Math.max(bu1 - bu0, bw1 - bw0), lo = Math.min(bu1 - bu0, bw1 - bw0);
    const err = Math.abs(hi - wantLong) + Math.abs(lo - wantShort);
    if (err < bestErr) { bestErr = err; faceD = dep; bestPts = face; }
  });

  let su = 0, sw = 0, sa = 0, eu0 = Infinity, eu1 = -Infinity, ew0 = Infinity, ew1 = -Infinity;
  (bestPts || []).forEach((f) => {
    su += f.u * f.area; sw += f.w * f.area; sa += f.area;
    if (f.u < eu0) eu0 = f.u; if (f.u > eu1) eu1 = f.u;
    if (f.w < ew0) ew0 = f.w; if (f.w > ew1) ew1 = f.w;
  });
  const cU = sa ? su / sa : 0, cW = sa ? sw / sa : 0;
  const extU = sa ? eu1 - eu0 : 0, extW = sa ? ew1 - ew0 : 0;
  const blobs = { length: nBlobs };

  // the longer count runs along the plate's longer edge
  const nU = extU >= extW ? long : short;
  const nW = extU >= extW ? short : long;
  const cells = [];
  for (let i = 0; i < nU; i++) {
    for (let j = 0; j < nW; j++) {
      cells.push({ u: cU + (i - (nU - 1) / 2) * PITCH, w: cW + (j - (nW - 1) / 2) * PITCH });
    }
  }

  // HOW HIGH the tile sits: the top of that cell's own STUD, measured off the
  // mesh rather than assumed. A flat level table can't name the stud (on this
  // family the stud top triangulates into a thin rim that scores like a plate
  // edge), but the stud is by definition the highest thing standing inside its
  // own cell — so take the furthest vertex along the face normal within a 3.2mm
  // disc of the cell centre. The disc stays inside the plate, which is what
  // keeps a huggie's ring and a pendant's bail — both taller than the drop and
  // both in this same plane — out of the measurement. (Tom 08-09)
  const CELL_R2 = 3.2 * 3.2;
  cells.forEach((c) => { c.top = -Infinity; });
  for (let i = 0; i < pos.count; i++) {
    a.fromBufferAttribute(pos, i);
    const vu = a.dot(p1), vw = a.dot(p2), vd = a.dot(e);
    cells.forEach((c) => {
      const du = vu - c.u, dw = vw - c.w;
      if (du * du + dw * dw <= CELL_R2 && vd > c.top) c.top = vd;
    });
  }
  // The plate surface is exactly one stud-height below the stud top — 1.8mm, a
  // constant of the click system, not a per-model guess. Measured off the meshes
  // it holds on all three families (stud 7.89 top / 6.09 plate, huggie 2.78 /
  // 0.98, pendant the same), and it is the CAD number these parts are cut to.
  // Reading the plate off the mesh instead — the ring of material beside each
  // stud — was what staggered the multi-cell drops: that ring also catches the
  // NEXT stud and the plate's own side wall, so it landed at a different height
  // per cell and the run of tiles came out as a staircase. (Tom 08-09)
  const STUD_H = 1.8;
  cells.forEach((c) => {
    if (!isFinite(c.top)) c.top = faceD + STUD_H;
    c.plate = c.top - STUD_H;
  });

  // tile edges parallel to the plate edges: tile +Z -> face normal, +X -> p1
  const align = new THREE.Quaternion().setFromRotationMatrix(
    new THREE.Matrix4().makeBasis(p1, p2, e));

  return { cells, faceD, e, p1, p2, align, dirWrap,
           nBlobs: blobs.length, extU: +extU.toFixed(1), extW: +extW.toFixed(1),
           want: [wantLong, wantShort], blobErr: +bestErr.toFixed(1) };
}

// `only` names one cell to color; leave it out and the whole face goes that
// color. A 1x2 / 1x3 / 2x2 is colored tile by tile from the slot chips, a 1x1
// has nothing to choose between. (Tom 08-09)
function cardTile(piece, hex, only) {
  const round = /round/.test(piece.cell.dataset.model || "");
  const geo = round ? tileRoundGeo : tileGeo;
  if (!geo || !piece.geo) return null;

  if (!piece.tiles) {
    const f = faceCells(piece);
    const tb = geo.boundingBox || (geo.computeBoundingBox(), geo.boundingBox);
    const ts = tb.getSize(new THREE.Vector3());
    const thickMm = Math.min(ts.x, ts.y, ts.z);    // tile plate thickness, in mm

    piece.tiles = f.cells.map((cell) => {
      const m = new THREE.Mesh(geo, PLASTIC(hex));
      // Outside of the tile only. PLASTIC is DoubleSide for the loose floaters,
      // but on a seated tile that renders the inner walls too — as it flew in you
      // could see straight into the hollow. FrontSide shows the finished outer
      // shell and nothing else. Per-tile material, so the floaters keep theirs.
      m.material.side = THREE.FrontSide;
      m.quaternion.copy(QX).multiply(f.align);
      m.scale.setScalar(piece.unit);               // same mm-per-unit as the product

      // tile bottom sits ON the plate plane, the stud hidden inside it
      const pMesh = new THREE.Vector3()
        .addScaledVector(f.p1, cell.u)
        .addScaledVector(f.p2, cell.w)
        // Underside flat ON the plate, exactly like a real tile: the tile is
        // 3.16mm thick and the stud only stands ~1.8mm proud, so the stud ends
        // up entirely INSIDE the tile and never breaks its face. That was the
        // fear behind the old +1.7 standoff, and the measurements say it can't
        // happen — the old rule just parked every tile a stud-height off its
        // face, which read as floating on anything seen at an angle. If a stud
        // ever were taller than the tile, fall back to resting on it. (Tom 08-09)
        .addScaledVector(f.e, Math.max(cell.plate, cell.top - thickMm + 0.15) + thickMm * 0.5);
      m.userData.seat = pMesh.multiplyScalar(piece.unit).applyQuaternion(QX).add(piece.meshOffset);
      m.userData.dir = f.dirWrap.clone();
      m.position.copy(m.userData.seat);
      // built bare: a tile only appears once it has been given a color, so
      // coloring one cell of a 1x3 doesn't drop the other two on as well
      m.visible = false;
      piece.wrap.add(m);
      return m;
    });
  } else {
    piece.tiles.forEach((m, i) => {
      if (only == null || i === only) { m.material = PLASTIC(hex); m.material.side = THREE.FrontSide; }
    });
  }

  // swoosh in from off the face, then click home — only the tile being placed
  piece.tiles.forEach((t, i) => {
    if (only != null && i !== only) return;
    const seat = t.userData.seat;
    // Come in from the VIEWER, not off the plate's own normal. The normal turns
    // with the piece, so once Tom span it round the tile started from behind and
    // swung in from the back. Toward-camera in the wrap's own space is +Z world
    // pulled back through the wrap's rotation, so the tile always arrives from
    // the front and clicks in. (Tom 08-09)
    const dir = new THREE.Vector3(0, 0, 1)
      .applyQuaternion(piece.wrap.getWorldQuaternion(new THREE.Quaternion()).invert());
    t.userData.hex = hex;
    t.visible = true;
    gsap.killTweensOf(t.position);
    t.position.copy(seat).addScaledVector(dir, 3.2);
    // fly in the OVER-scene: always in front of the metal, never see-through
    flyHost = piece.wrap;
    flyWrap.add(t);
    gsap.to(t.position, {
      x: seat.x, y: seat.y, z: seat.z,
      duration: 0.55, delay: only != null ? 0 : i * 0.07, ease: "back.out(2.2)",
      onComplete: () => { piece.wrap.add(t); },     // home, and back under normal depth
    });
  });
  return piece.tiles[0];
}

// QC handle: lets a probe read the seating maths per model instead of guessing
// from pixels (Tom 08-09 tile placement pass)
window.__qcTiles = {
  pieceOf: deckPieceOf,
  faceCells,
  report() {
    const out = [];
    document.querySelectorAll(".deck .citem").forEach((c, i) => {
      const piece = deckPieceOf.get(c);
      if (!piece || !piece.geo) return out.push({ i: i + 1, model: c.dataset.model, err: "no piece" });
      const f = faceCells(piece);
      const bb = piece.geo.boundingBox;
      const sz = bb.getSize(new THREE.Vector3());
      out.push({
        i: i + 1, model: c.dataset.model,
        axis: ["x", "y", "z"][[Math.abs(f.e.x), Math.abs(f.e.y), Math.abs(f.e.z)].indexOf(1)],
        sign: f.e.x + f.e.y + f.e.z > 0 ? "+" : "-",
        cells: f.cells.length,
        faceD: +f.faceD.toFixed(2),
        modelSize: [sz.x, sz.y, sz.z].map((v) => +v.toFixed(1)),
        tilePos: piece.tiles ? piece.tiles.map((t) => [t.position.x, t.position.y, t.position.z].map((v) => +v.toFixed(1))) : null,
      });
    });
    return out;
  },
};

// Which tile the color lands on. The bench tracks a selected cell; every other
// card has a single face and colors the lot. (Tom 08-09)
let benchSlot = 0;

document.querySelectorAll(".tsw").forEach((s) => {
  if (s.classList.contains("tsw-custom")) return;    // the color input has its own wiring
  s.addEventListener("click", () => {
    s.parentElement.querySelectorAll(".tsw").forEach((x) => x.classList.remove("sel"));
    s.classList.add("sel");
    const card = s.closest(".citem");
    const piece = card && deckPieceOf.get(card);
    if (!piece) return;
    if (s.classList.contains("tsw-none")) {          // clear the piece back to bare metal
      s.classList.remove("sel");
      if (piece.tiles) piece.tiles.forEach((t) => { gsap.killTweensOf(t.position); piece.wrap.add(t); t.visible = false; t.userData.hex = null; });
      syncSlots();
      return;
    }
    paintTile(card, piece, s.dataset.hex != null ? +s.dataset.hex : LEGO[s.dataset.tile]);
  });
});

function paintTile(card, piece, hex) {
  const multi = cellsOf(card.dataset.model) > 1 && card.closest(".st-bench");
  cardTile(piece, hex, multi ? benchSlot : null);
  syncSlots();
}

// product card: swatch select + add-to-cart feedback
// swatches repaint the card's actual 3D product (Tom 08-08)
const FINISH = {
  Chrome: { color: 0xdcdfe2, roughness: 0.07 },
  Gold:   { color: 0xF6D64F, roughness: 0.09 },
  Black:  { color: 0x2A2B30, roughness: 0.17 },
};
document.querySelectorAll(".sw").forEach((s) => {
  s.addEventListener("click", () => {
    s.parentElement.querySelectorAll(".sw").forEach((x) => x.classList.remove("sel"));   // per-card selection
    s.classList.add("sel");
    const f = FINISH[s.dataset.name];
    const card = s.closest(".citem");
    if (!f || !card) return;
    const piece = deckPieceOf.get(card);
    const mats = (piece && piece.mats) || [];
    if (card === heroCard && heroCan) mats.push(...(heroCan.userData.mats || []));
    mats.forEach((m) => { m.color.setHex(f.color); m.roughness = f.roughness; m.needsUpdate = true; });
  });
});
// ---- STUDIO: tile slots, custom color, and the bench view ----
const benchCardEl = stBench && stBench.querySelector(".citem");
const stSlots = benchCardEl && benchCardEl.querySelector(".st-slots");

// The chips mirror what is actually on the piece: one per stud, each wearing the
// color of the tile in that cell, the selected one outlined.
function syncSlots() {
  if (!stSlots) return;
  const n = cellsOf(benchCardEl.dataset.model);
  const piece = deckPieceOf.get(benchCardEl);
  stSlots.querySelectorAll(".st-slot").forEach((x) => x.remove());
  if (benchSlot >= n) benchSlot = 0;
  {
    for (let i = 0; i < n; i++) {
      const b = document.createElement("button");
      b.type = "button";
      b.className = "st-slot" + (i === benchSlot ? " sel" : "");
      b.textContent = String(i + 1);
      const t = piece && piece.tiles && piece.tiles[i];
      if (t && t.visible && t.userData.hex != null) {
        b.classList.add("filled");
        b.style.background = "#" + t.userData.hex.toString(16).padStart(6, "0");
      }
      b.addEventListener("click", () => { benchSlot = i; syncSlots(); });
      stSlots.appendChild(b);
    }
  }
}

// The browser's own color dialog can't be styled at all, so the custom chip
// opens OUR picker instead: a saturation/value field over a hue rail, in the
// page's border/­type language, applying live to the selected tile.
// (Tom 08-09: "fix the css for the color picker popup to match the website")
if (benchCardEl) {
  const custom = benchCardEl.querySelector(".tsw-custom");
  const pick = document.createElement("div");
  pick.className = "st-pick";
  pick.hidden = true;
  pick.innerHTML =
    '<canvas class="st-pick-sv" width="172" height="112"></canvas>' +
    '<canvas class="st-pick-hue" width="172" height="12"></canvas>' +
    '<div class="st-pick-foot"><span class="st-pick-hex">#0C00FF</span>' +
    '<button type="button" class="st-pick-done">Done</button></div>';
  benchCardEl.querySelector(".st-panel").appendChild(pick);

  const sv = pick.querySelector(".st-pick-sv"), hue = pick.querySelector(".st-pick-hue");
  const hexOut = pick.querySelector(".st-pick-hex");
  const svc = sv.getContext("2d"), huec = hue.getContext("2d");
  let H = 0.66, S = 1, V = 1;                       // opens on VOID blue

  const hsv2rgb = (h, s, v) => {
    const i = Math.floor(h * 6), f = h * 6 - i;
    const p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s);
    const r = [v, q, p, p, t, v][i % 6], g = [t, v, v, q, p, p][i % 6], b = [p, p, t, v, v, q][i % 6];
    return (Math.round(r * 255) << 16) | (Math.round(g * 255) << 8) | Math.round(b * 255);
  };
  const drawHue = () => {
    const g = huec.createLinearGradient(0, 0, hue.width, 0);
    for (let i = 0; i <= 6; i++) g.addColorStop(i / 6, "#" + hsv2rgb(i / 6, 1, 1).toString(16).padStart(6, "0"));
    huec.fillStyle = g; huec.fillRect(0, 0, hue.width, hue.height);
    huec.fillStyle = "#111"; huec.fillRect(Math.round(H * hue.width) - 1, 0, 2, hue.height);
  };
  const drawSV = () => {
    const base = huec.createLinearGradient(0, 0, sv.width, 0);
    svc.fillStyle = "#" + hsv2rgb(H, 1, 1).toString(16).padStart(6, "0");
    svc.fillRect(0, 0, sv.width, sv.height);
    let g = svc.createLinearGradient(0, 0, sv.width, 0);
    g.addColorStop(0, "rgba(255,255,255,1)"); g.addColorStop(1, "rgba(255,255,255,0)");
    svc.fillStyle = g; svc.fillRect(0, 0, sv.width, sv.height);
    g = svc.createLinearGradient(0, 0, 0, sv.height);
    g.addColorStop(0, "rgba(0,0,0,0)"); g.addColorStop(1, "rgba(0,0,0,1)");
    svc.fillStyle = g; svc.fillRect(0, 0, sv.width, sv.height);
    svc.strokeStyle = "#fff"; svc.lineWidth = 1.5;
    svc.beginPath(); svc.arc(S * sv.width, (1 - V) * sv.height, 5, 0, Math.PI * 2); svc.stroke();
    svc.strokeStyle = "#111"; svc.lineWidth = 1;
    svc.beginPath(); svc.arc(S * sv.width, (1 - V) * sv.height, 6.5, 0, Math.PI * 2); svc.stroke();
    void base;
  };
  const apply = () => {
    const hex = hsv2rgb(H, S, V);
    hexOut.textContent = "#" + hex.toString(16).padStart(6, "0").toUpperCase();
    const piece = deckPieceOf.get(benchCardEl);
    if (piece) paintTile(benchCardEl, piece, hex);
  };
  const paint = () => { drawHue(); drawSV(); apply(); };

  const track = (el, onMove) => {
    let on = false;
    const run = (e) => {
      const r = el.getBoundingClientRect();
      onMove(Math.min(1, Math.max(0, (e.clientX - r.left) / r.width)),
             Math.min(1, Math.max(0, (e.clientY - r.top) / r.height)));
      paint();
    };
    el.addEventListener("pointerdown", (e) => { on = true; el.setPointerCapture(e.pointerId); run(e); });
    el.addEventListener("pointermove", (e) => { if (on) run(e); });
    el.addEventListener("pointerup", (e) => { on = false; try { el.releasePointerCapture(e.pointerId); } catch (_) {} });
  };
  track(sv, (x, y) => { S = x; V = 1 - y; });
  track(hue, (x) => { H = x; });

  custom.addEventListener("click", (e) => {
    e.stopPropagation();
    benchCardEl.querySelectorAll(".tsw").forEach((x) => x.classList.remove("sel"));
    custom.classList.add("sel");
    if (!pick.hidden) { pick.hidden = true; return; }
    // unhide FIRST: a display:none element has no offsetParent, so measuring
    // before showing it threw and the popover never opened
    pick.hidden = false;
    const cr = custom.getBoundingClientRect();
    const pr = (pick.offsetParent || pick.parentElement).getBoundingClientRect();
    pick.style.left = Math.max(8, Math.min(cr.left - pr.left - 60, pr.width - 212)) + "px";
    pick.style.top = "auto";
    pick.style.bottom = (pr.bottom - cr.top + 10) + "px";
    paint();
  });
  pick.addEventListener("pointerdown", (e) => e.stopPropagation());
  pick.querySelector(".st-pick-done").addEventListener("click", () => { pick.hidden = true; });
  document.addEventListener("pointerdown", () => { pick.hidden = true; });

  syncSlots();
}

// The bench is a workspace, so the piece takes the same handling as the studio
// builder: drag to turn it, shift-drag to slide it, wheel to zoom. The sway runs
// until the first touch and then holds still, so what Tom lines up stays lined
// up. (Tom 08-09)
const benchView = { rx: 0, ry: 0, zoom: 1, px: 0, py: 0, touched: false };
window.__benchView = benchView;   // QC handle
if (stBench) {
  const card = stBench.querySelector(".citem");
  const stage = card.querySelector(".st-stage");
  let drag = null;
  stage.addEventListener("pointerdown", (e) => {
    drag = { x: e.clientX, y: e.clientY, pan: e.shiftKey || e.button === 1 };
    benchView.touched = true;
    card.classList.add("dragging");
    stage.setPointerCapture(e.pointerId);
  });
  stage.addEventListener("pointermove", (e) => {
    if (!drag) return;
    const dx = e.clientX - drag.x, dy = e.clientY - drag.y;
    drag.x = e.clientX; drag.y = e.clientY;
    if (drag.pan) { benchView.px += dx; benchView.py -= dy; }
    else {
      // both axes spin freely and without limit — vertical used to be clamped
      // to +/-1.3rad (~74deg) so the piece stopped short going up and over,
      // while horizontal span as many turns as you liked (Tom 08-10)
      benchView.ry += dx * 0.01;
      benchView.rx += dy * 0.01;
    }
  });
  const stop = (e) => { if (drag) { card.classList.remove("dragging"); try { stage.releasePointerCapture(e.pointerId); } catch (_) {} drag = null; } };
  stage.addEventListener("pointerup", stop);
  stage.addEventListener("pointercancel", stop);
  /* Two-finger pinch drives the product's zoom and never reaches the page.
     Single-finger drag already goes through the pointer handlers above. (Tom 08-11) */
  let pinch0 = 0, zoom0 = 1, t0x = 0, t0y = 0, axis = "", mx = 0, my = 0;
  const dist = (t) => Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);
  const mid = (t) => [(t[0].clientX + t[1].clientX) / 2, (t[0].clientY + t[1].clientY) / 2];
  stage.addEventListener("touchstart", (e) => {
    if (e.touches.length === 2) {
      pinch0 = dist(e.touches); zoom0 = benchView.zoom;
      [mx, my] = mid(e.touches);            // two-finger drag slides the piece
      e.preventDefault();
    }
    else if (e.touches.length === 1) { t0x = e.touches[0].clientX; t0y = e.touches[0].clientY; axis = ""; }
  }, { passive: false });
  stage.addEventListener("touchmove", (e) => {
    if (e.touches.length === 2 && pinch0) {
      benchView.touched = true;
      benchView.zoom = Math.max(0.35, Math.min(4, zoom0 * (dist(e.touches) / pinch0)));
      /* ...and the midpoint of the two fingers PANS it, so "two-finger drag to
         slide" is a move that exists rather than a hint for a mouse the phone
         does not have. Same sign convention as the shift-drag above. (Tom 08-11) */
      const [nx, ny] = mid(e.touches);
      benchView.px += nx - mx; benchView.py -= ny - my;
      mx = nx; my = ny;
      e.preventDefault();
    } else if (e.touches.length === 1) {
      /* A ONE-FINGER DRAG BELONGS TO WHICHEVER IT LOOKS LIKE.
         This used to preventDefault every single-finger move to "keep a turn off
         the page scroll" — but the stage is most of a phone screen, so scrolling
         DOWN THE PAGE past the studio meant dragging across it, and the section
         simply refused to move. Measured: a full swipe on the stage scrolled the
         page 0px. Now the first few pixels decide: mostly sideways turns the
         product (and we swallow the event), mostly up-and-down is a page scroll
         and we keep our hands off it. Paired with touch-action:pan-y, so the
         browser can own the vertical axis and still hand us the horizontal one —
         and pinch-zoom stays ours, because pan-y excludes it. (Tom 08-11) */
      if (!axis) {
        const dx = Math.abs(e.touches[0].clientX - t0x);
        const dy = Math.abs(e.touches[0].clientY - t0y);
        if (dx > 6 || dy > 6) axis = dx > dy ? "turn" : "scroll";
      }
      if (axis === "turn") e.preventDefault();
    }
  }, { passive: false });
  stage.addEventListener("touchend", () => { pinch0 = 0; axis = ""; }, { passive: true });

  stage.addEventListener("wheel", (e) => {
    e.preventDefault();
    benchView.touched = true;
    // scale with the delta, so one big trackpad flick zooms as far as a
    // dozen mouse notches instead of a single 10% step
    benchView.zoom = Math.max(0.35, Math.min(4, benchView.zoom * Math.exp(-e.deltaY * 0.0016)));
  }, { passive: false });
}

// ---- STUDIO: picking a piece off the rail puts it on the bench ----
// The bench keeps its material instance across the swap, so the finish Tom chose
// carries onto the next piece; the tiles do not, because a tile is seated
// against the geometry it was built for. (Tom 08-09)
if (stBench && stRail) {
  const benchCard = stBench.querySelector(".citem");
  stRail.querySelectorAll(".citem").forEach((thumb) => {
    thumb.addEventListener("click", () => {
      const pr = ST_ALL[+thumb.dataset.pick];
      if (!pr || benchCard.dataset.model === pr.model) return;
      stRail.querySelectorAll(".citem").forEach((x) => x.classList.remove("on"));
      thumb.classList.add("on");
      benchCard.dataset.model = pr.model;
      benchCard.dataset.kind = pr.kind;
      benchCard.querySelector(".st-name").textContent = pr.name;
      benchCard.querySelectorAll(".tsw").forEach((x) => x.classList.remove("sel"));
      // a fresh piece comes back to the bench square-on at its resting size
      benchView.rx = benchView.ry = benchView.px = benchView.py = 0;
      benchView.zoom = 1;
      benchView.touched = false;
      benchSlot = 0;
      const piece = deckPieceOf.get(benchCard);
      if (piece) setPieceModel(piece, pr.model, COLLECTION_KIND[pr.kind]).then(syncSlots);
      syncSlots();
    });
  });
}

/* SHOP NOW: every card's button links to that piece's product page on mrsfc.com.
   The cards are clones of #01, so each one inherits #01's href; point it at its
   own product from the card's model. Replaces the old add-to-cart. (Tom 10-15) */
const PRODUCT_URL = {
  "stud-earring-1x1-square.stl": "connex-stud-earring-1x1-square-chrome",
  "stud-earring-1x1-round.stl":  "connex-stud-earring-1x1-round-chrome",
  "click-hoop-1x1-square.stl":   "connex-huggie-earring-1x1-square-chrome",
  "click-hoop-1x1-round.stl":    "connex-huggie-earring-1x1-round-chrome",
  "click-hoop-1x2.stl":          "connex-huggie-earring-1x2-chrome",
  "click-hoop-1x3.stl":          "connex-huggie-earring-1x3-chrome",
  "click-hoop-2x2.stl":          "connex-huggie-earring-2x2-chrome",
  "pendant-1x1-round-bail.stl":  "connex-pendant-1x1-round-chrome",
  "pendant-1x1-square-bail.stl": "connex-pendant-1x1-square-chrome",
  "pendant-1x2-bail.stl":        "connex-pendant-1x2-chrome",
  "pendant-1x3-bail.stl":        "connex-pendant-1x3-chrome",
  "pendant-2x2-bail.stl":        "connex-pendant-2x2-chrome",
};
function linkShopNow() {
  document.querySelectorAll("a.atc").forEach((a) => {
    const card = a.closest("[data-model]");
    const h = card && PRODUCT_URL[card.dataset.model];
    if (h) a.href = "https://mrsfc.com/products/" + h;
  });
}
linkShopNow();
/* the studio bench swaps its model when you pick a piece; re-point after any click */
document.addEventListener("click", () => setTimeout(linkShopNow, 0), true);

/* MOBILE ONLY — the floating fleet is laid out in world units tuned for a wide
   desktop viewport, so on a phone the pieces rendered enormous and ran off both
   edges. Scaling the whole group pulls their SPREAD positions in as well as
   their size, so the same composition just fits the narrow screen. Desktop is
   untouched (factor 1). (Tom 08-10) */
function fitFleet() {
  const w = window.innerWidth;
  const k = w < 480 ? 0.46 : w < 768 ? 0.62 : 1;
  products.scale.setScalar(k);
}
fitFleet();

/* THE MOBILE "ZOOM". On a phone the URL bar collapses as you scroll past the
   hero: innerHeight jumps, resize fires, the camera aspect and renderer size
   change, and every product visibly grows mid-scroll. Nothing was animating —
   it was the viewport moving under us. So a HEIGHT-ONLY change is ignored on
   touch widths; only a real width change (rotation) re-fits. (Tom 08-10) */
let lastW = window.innerWidth, lastH = window.innerHeight;
/* ── MOBILE: cards slide in, hero hands off, and the canvas stops juddering ──
   1. Each card animates itself as it reaches the viewport — the same slide-up
      the desktop deck does, but driven per card instead of by a pinned
      sequence, so they arrive on time and in order.
   2. The hero product is hidden once the deck is reached and restored on the
      way back; on mobile the pinned onUpdate that used to do that no longer
      runs for the whole section.
   3. THE JUDDER: the 3D canvas is position:fixed while the cards scroll, and
      the pieces are placed each frame from getBoundingClientRect(). Under
      Lenis's smoothed scroll on iOS the rect and the painted page are a frame
      apart, which reads as the products jittering up and down. Lenis is turned
      off on touch widths so the canvas and the page share one scroll position.
   (Tom 08-10) */
if (window.innerWidth <= 768) {
  /* BOLD STACKING: the stamp and the three chips share one row, stamp hard left.
     They are absolutely positioned siblings on the web, so on mobile they get a
     flex row wrapper — CSS alone cannot pair them. (Tom 08-10) */
  (function () {
    const th = document.querySelector(".thinking");
    const stamp = th && th.querySelector(".stamp");
    const chips = th && th.querySelector(".chips");
    if (th && stamp && chips && !th.querySelector(".tkrow")) {
      const row = document.createElement("div");
      row.className = "tkrow";
      th.insertBefore(row, stamp);
      row.appendChild(stamp);
      row.appendChild(chips);
    }
  })();

  /* PHONE ONLY — HOW A BASE IS MADE reads text-first: the sentence sits ABOVE
     its number, not under it. (Tom 08-12: "move the text above the numbers so
     like cnc machined from solid stock is above the 01".)
     Done by moving the .sp-n node to the end of its call-out rather than with
     flex order, because the sentence is a bare text node — a reversed flex
     column would make it an anonymous item and take the per-corner text
     alignment with it. Moving the node keeps plain block layout, and the leader
     lines still anchor to the digits because drawCallouts() measures .sp-n
     wherever it is. Web is untouched. */
  /* TOP PAIR ONLY. 01 and 02 read text-then-number; 03 and 04 go back to
     number-then-text, which is where they started. (Tom 08-12, second pass:
     "put back the text below the number 03 and 04 - leave the text above 01 and
     02".) It also puts each number on the side of its call-out that faces the
     product: 01/02 sit above the piece so their digits end up nearest it, 03/04
     sit below so theirs do — the leader lines get shorter, not longer. */
  document.querySelectorAll(".callouts .sp-tl, .callouts .sp-tr").forEach((sp) => {
    const n = sp.querySelector(".sp-n");
    if (n) sp.appendChild(n);
  });

  /* PHONE ONLY — the product card carries BULLETS, not a paragraph.
     A 175px-wide card turned every description into a five-line block of prose
     nobody reads on a phone. Three short facts instead: what it is, how it
     fastens, and what it takes. The web build keeps its paragraph untouched —
     this rewrite only ever runs under 768px. (Tom 08-11) */
  (function () {
    const studs = (m) => { const x = /(\d)x(\d)/.exec(m || ""); return x ? +x[1] * +x[2] : 1; };
    const bullets = (card) => {
      const model = card.dataset.model || "", kind = card.dataset.kind || "stud";
      const n = studs(model);
      const face = n + (n === 1 ? " stud" : " studs") + ", tile-ready";
      if (kind === "hoop") return ["Hinged huggie, clicks shut", "Sits close on the lobe", face];
      if (kind === "pendant") return ["Closed bail, fits any chain", "Hangs flat, face forward", face];
      return ["12mm hypoallergenic post", "Locking notch, friction back", face];
    };
    deckCards.forEach((card) => {
      const desc = card.querySelector(".p-desc");
      if (!desc) return;
      const ul = document.createElement("ul");
      ul.className = "p-bul";
      bullets(card).forEach((t) => {
        const li = document.createElement("li");
        li.textContent = t;
        ul.appendChild(li);
      });
      desc.replaceWith(ul);
    });
    /* cardBits/cardTl (card #01's block-by-block assembly) is a DESKTOP reveal —
       on a phone updateDeck() forces cardTl.progress(1) and the whole card
       slides in as one, so the removed .p-desc target is simply never played. */
  })();

  /* PHONE ONLY — the workspace tells you how to drive it, and gives you a way
     back. The web hints (.st-hints: DRAG TO TURN / SHIFT-DRAG TO SLIDE / SCROLL
     TO ZOOM) are display:none on a phone and describe a mouse anyway, so the
     panel gets its own set naming the touch gestures that actually work, plus a
     RESET that puts the piece back at its starting size, angle and position.
     (Tom 08-11) */
  (function () {
    const panel = document.querySelector(".st-bench .st-panel");
    if (!panel) return;

    const reset = document.createElement("button");
    reset.type = "button";
    reset.className = "st-reset";
    reset.textContent = "Reset view";
    reset.addEventListener("click", () => {
      benchView.rx = benchView.ry = benchView.px = benchView.py = 0;
      benchView.zoom = 1;
      benchView.touched = false;      // the resting sway picks up again
    });

    const wrap = document.createElement("div");
    wrap.className = "st-hints st-mhints";
    [["turn", "Drag to turn"], ["zoom", "Pinch to zoom"], ["slide", "Two-finger drag to slide"]]
      .forEach(([k, text]) => {
        const q = document.createElement("p");
        q.className = "st-hint";
        q.innerHTML = '<svg viewBox="0 0 12 12" aria-hidden="true">' + HINT_ICONS[k] + "</svg><span></span>";
        q.querySelector("span").textContent = text;
        wrap.appendChild(q);
      });
    panel.append(wrap, reset);
  })();

  /* PHONE ONLY — the workspace controls run ACROSS THE BOTTOM, not down the
     side. (Tom 08-12: "put the controls horizontally on the bottom so shift
     everything to the bottom. i think we will need the columns. the first will
     have the name 01 and 02, then next column has the colors ... then the
     instructions and reset button in the last column.")
     A 104px-wide column down the left of a 358px card spent a third of the
     screen on controls and still could not hold a step title on one line. Along
     the bottom the same controls get the full width and the piece gets the whole
     card to stand in. The panel keeps its own DOM node (the colour picker
     anchors to it); only the children are re-grouped into three columns, and
     .st-pick is deliberately left where it is. */
  (function () {
    const panel = document.querySelector(".st-bench .st-panel");
    if (!panel || panel.querySelector(".st-col")) return;
    const pick = (s) => panel.querySelector(s);
    const steps = [...panel.querySelectorAll(".st-step")];
    const col = (cls) => { const d = document.createElement("div"); d.className = "st-col " + cls; return d; };

    const c1 = col("st-col-a"), c2 = col("st-col-b"), c3 = col("st-col-c");
    // column 1 — who it is, then step 01 (finish) and step 02 (which stud)
    [pick(".st-name"), steps[0], pick(".p-colors:not(.st-tilecolors)"), steps[1], pick(".st-slots")]
      .forEach((n) => n && c1.appendChild(n));
    // column 2 — step 03 and the colour grid
    [steps[2], pick(".st-tilecolors")].forEach((n) => n && c2.appendChild(n));
    // column 3 — how to drive it, and the way back
    [pick(".st-mhints"), pick(".st-reset")].forEach((n) => n && c3.appendChild(n));
    panel.prepend(c1, c2, c3);

    /* THE PHONE PALETTE IS TWO ROWS SHORTER, AND THE STAGE GETS THE ROOM.
       Six across x six down (34 colours + the custom chip + the remove chip) was
       a 99px-tall block of swatches on a 390px screen. Dropping the twelve
       weakest leaves 22 + 2 = 24 = four full rows, no gap, and the workspace
       above grows by what the bar gives back — the stage is flex:1 in a
       fixed-height card, so this is automatic.
       "Weakest" = the muted and near-duplicate shades, the ones that read as grey
       -ish versions of a colour already in the grid: the sands, the olives, the
       dark variants that sit beside their own brighter parent. Every primary,
       every neutral and one clear example of each hue family stays. Web keeps
       all 34 — its panel has the height for them. (Tom 08-12) */
    const WEAK = ["Dark Tan", "Sand Green", "Sand Blue", "Light Aqua", "Yellowish Green",
                  "Nougat", "Olive Green", "Dark Orange", "Dark Purple", "Dark Red",
                  "Brown", "Bright Pink"];
    const COLS = 6;
    const tiles = pick(".st-tilecolors");
    if (tiles) {
      WEAK.forEach((name) => {
        const s = tiles.querySelector('.tsw[title="' + name + '"]');
        if (s) s.remove();
      });
      // belt and braces: if the palette ever changes under this list, drop
      // trailing COLOURS (never the custom / remove chips) until the last row is
      // full again, so the grid can never end in dead space
      const plain = [...tiles.querySelectorAll(".tsw")]
        .filter((s) => !s.classList.contains("tsw-custom") && !s.classList.contains("tsw-none"));
      while (tiles.querySelectorAll(".tsw").length % COLS !== 0 && plain.length) plain.pop().remove();
    }
  })();

  deckCards.forEach((el) => {
    gsap.set(el, { opacity: 0, y: 46 });
    /* the piece is resolved INSIDE the callback: pieces are built after the
       models finish loading, so looking it up at setup time always gave
       undefined and the 3D product never popped in (Tom 08-10) */
    const piece = () => deckPieceOf.get(el);
    ScrollTrigger.create({
      trigger: el,
      start: "top 92%",
      onEnter: () => {
        gsap.to(el, { opacity: 1, y: 0, duration: 0.55, ease: "power2.out" });
        const pc = piece();
        if (pc) gsap.to(pc, { pop: 1, duration: 0.55, ease: "power2.out", overwrite: true });
      },
      onLeaveBack: () => {
        gsap.to(el, { opacity: 0, y: 46, duration: 0.3 });
        const pc = piece();
        if (pc) gsap.to(pc, { pop: 0, duration: 0.3, overwrite: true });
      },
    });
  });
  ScrollTrigger.create({
    trigger: ".scanner",
    /* "top 80%" hid the main product the moment the card section had shown a
       fifth of itself — a whole screen before the cards were anywhere near, so
       it just vanished mid-scroll. It now holds until the card grid has almost
       reached it. Not later than this: the phone has no shrink-into-the-card
       hand-off, so the product simply switches off, and measured at 390x844 the
       first row of cards reaches the product's own screen position at about
       "top 45%" — hiding after that means it blinks out ON TOP of card #02.
       50% is the last frame where it disappears in clear air. (Tom 08-11) */
    start: "top 50%",
    onEnter: () => { if (heroCan) heroCan.visible = false; },
    onLeaveBack: () => {
      if (!heroCan) return;
      heroCan.visible = true;
      heroCan.scale.setScalar(heroCan.userData.scale);
    },
  });
}

/* The first band measurement can land before the webfont has swapped in, which
   moves the label and the content block by a couple of pixels. Re-measure once
   the page is fully loaded and once more after the font settles. */
window.addEventListener("load", () => { bandGen++; setTimeout(() => bandGen++, 700); });

window.addEventListener("resize", () => {
  const w = window.innerWidth, h = window.innerHeight;
  if (w <= 768 && w === lastW && h !== lastH) { lastH = h; return; }
  lastW = w; lastH = h;
  /* THE ONLY PLACE VW/VH MOVE — they are set in the same breath as
     renderer.setSize(), so the canvas and the placement maths can never end up
     describing two different viewports (the studio glitch). (Tom 08-11) */
  VW = w; VH = h;
  camera.aspect = w / h;
  camera.updateProjectionMatrix();
  renderer.setSize(w, h);
  fitFleet();
  sizeDeckCam();
  measureDeck();
  bandGen++;              // every cached card band is re-measured on the next frame
});

// ---- HOW A BASE IS MADE: orthogonal leader lines ----
// Each call-out sends one elbow: it drops (or rises) vertically off the end of
// its own rule, turns exactly 90 degrees, then runs horizontally at the product
// and STOPS short of it — the line points in from the side, it never touches the
// metal. Top pair aim above centre, bottom pair below, so the two verticals on
// each side can't meet. (Tom 08-09)
const coSec = document.querySelector(".callouts");
const coSvg = coSec && coSec.querySelector(".co-lines");
const coItems = coSvg ? [
  { el: coSec.querySelector(".sp-tl"), ln: coSvg.querySelector('[data-co="tl"]'), side: "left",  half: "top" },
  { el: coSec.querySelector(".sp-tr"), ln: coSvg.querySelector('[data-co="tr"]'), side: "right", half: "top" },
  { el: coSec.querySelector(".sp-bl"), ln: coSvg.querySelector('[data-co="bl"]'), side: "left",  half: "bottom" },
  { el: coSec.querySelector(".sp-br"), ln: coSvg.querySelector('[data-co="br"]'), side: "right", half: "bottom" },
] : [];

const coV = new THREE.Vector3();

function drawCallouts() {
  if (!coSvg || !heroCan) return;
  const sec = coSec.getBoundingClientRect();
  if (sec.bottom < 0 || sec.top > window.innerHeight) return;   // off screen, skip

  // Hold the leaders off the product until the section has actually arrived,
  // then slide each one in from its own side. Drawing them while the screen is
  // still travelling put lines across the product on the way in. (Tom 08-09)
  const vhh = window.innerHeight;
  const settle = Math.min(1, Math.max(0, 1 - sec.top / (vhh * 0.42)));
  // ...and take them away again as the screen leaves, so the product carries on
  // down to the card on its own instead of dragging leader lines over it.
  // gone well before the product card arrives: fully faded by the time the
  // section's bottom edge is still 0.9vh down the screen, which is roughly when
  // the card has shown about a third of itself (Tom 08-09)
  // The card sits directly under this section, so the fraction of it on screen
  // is (vh - sec.bottom)/vh. Fully faded by sec.bottom = 0.7vh, i.e. once about
  // 30% of the card is showing. The section is 88vh tall, so 0.88vh is the
  // settled value and the band has to sit below that. (Tom 08-09)
  /* HOW LONG THE LEADERS STAY. They fade as the section leaves; the web build
     takes them away early (bottom edge still 0.7vh down the screen) so they are
     gone well before the product card arrives underneath.
     On a phone that was far too eager — the section is short, so 0.7vh is
     reached while HOW A BASE IS MADE is still the thing you are reading, and the
     lines vanished out from under it. The phone holds them until the section is
     nearly off the bottom (0.12vh) instead. Web keeps its own number.
     (Tom 08-12: "make the lines stay longer - they disappear too soon") */
  const LEAVE_AT = MOB ? 0.55 : 0.7;   // phone 0.12 -> 0.55: Tom 10-10 "make the lines disappear sooner" on mobile
  const leave = Math.min(1, Math.max(0, (sec.bottom - vhh * LEAVE_AT) / (vhh * 0.15)));
  /* PHONE: TIED TO THE EARRING BEING CENTRED. The leaders used to fade in while the
     call-outs were still far below the earring, so they arrived as long stretched
     brackets, and lingered as the text scrolled away. On a phone they are now fully out
     (no slide) only while the section sits centred around the earring, and fade fast
     either side. (Tom 10-15: "have the lines already out and close to the earring when
     it is in the center and goes away as it scrolls") */
  // 0.435vh = where the section's centre sits when the earring is framed by the four call-outs (measured 390x844)
  const off = Math.abs((sec.top + sec.bottom) / 2 - vhh * 0.435) / vhh;
  const t01 = MOB ? Math.min(1, Math.max(0, (0.12 - off) / 0.07)) : Math.min(settle, leave);
  const alpha = t01 * t01 * (3 - 2 * t01);                      // smoothstep
  if (t01 <= 0) {                                               // not here yet, or gone
    coItems.forEach((it) => it.ln && it.ln.setAttribute("opacity", 0));
    return;
  }

  // the product's real screen box: project the 8 corners of the mesh's own
  // bounding box, so a line stops ON the silhouette instead of on a circle that
  // leaves the narrow sides hanging in space
  const mesh = heroCan.children.find((c) => c.isMesh);
  if (!mesh || !mesh.geometry.boundingBox) return;
  const bb = mesh.geometry.boundingBox;
  const pts = [];
  let x0 = Infinity, x1 = -Infinity, y0 = Infinity, y1 = -Infinity;
  for (let i = 0; i < 8; i++) {
    coV.set(i & 1 ? bb.max.x : bb.min.x, i & 2 ? bb.max.y : bb.min.y, i & 4 ? bb.max.z : bb.min.z);
    coV.applyMatrix4(mesh.matrixWorld).project(camera);
    const sx = (coV.x * 0.5 + 0.5) * VW - sec.left;
    const sy = (-coV.y * 0.5 + 0.5) * VH - sec.top;
    pts.push([sx, sy]);
    if (sx < x0) x0 = sx;
    if (sx > x1) x1 = sx;
    if (sy < y0) y0 = sy;
    if (sy > y1) y1 = sy;
  }
  // the 12 edges of that projected box. The overall box is far too wide at most
  // heights (the ear-nut juts out low and right, padding every row), so a leader
  // aimed at x0/x1 stops way out in empty space. Slicing the box at the line's
  // own row gives the width the product actually has THERE. (Tom 08-09)
  const EDGES = [[0,1],[2,3],[4,5],[6,7],[0,2],[1,3],[4,6],[5,7],[0,4],[1,5],[2,6],[3,7]];
  function widthAtRow(ry) {
    let lo = Infinity, hi = -Infinity;
    for (const [a, b] of EDGES) {
      const p = pts[a], q = pts[b];
      if ((p[1] - ry) * (q[1] - ry) > 0) continue;              // edge doesn't span this row
      if (p[1] === q[1]) { lo = Math.min(lo, p[0], q[0]); hi = Math.max(hi, p[0], q[0]); continue; }
      const x = p[0] + (q[0] - p[0]) * ((ry - p[1]) / (q[1] - p[1]));
      if (x < lo) lo = x;
      if (x > hi) hi = x;
    }
    return lo <= hi ? [lo, hi] : [x0, x1];                      // fall back to the full box
  }
  /* clear air between the end of a leader and the metal. On a phone the product
     is drawn small in a narrow column and the four call-outs sit close in, so
     18px was letting a leader run right up to (and at some poses over) the
     silhouette. 34px on a phone; the web build keeps its 18. (Tom 08-11) */
  const GAP = MOB ? 34 : 18;            // clear air between line end and the metal
  // aim the horizontal approach near the product's upper / lower thirds rather
  // than at dead centre: keeps the vertical leg short so each leader reads as a
  // tight elbow instead of a tall empty bracket
  const INSET = (y1 - y0) * 0.22;

  coItems.forEach((it) => {
    if (!it.el || !it.ln) return;
    const b = it.el.getBoundingClientRect();
    /* THE LEADER STARTS AT ITS NUMBER. It used to start at the top edge of the
       whole call-out paragraph, which put the line above 01/02/03/04 and offset
       from them — reading as a rule that happened to sit nearby rather than a
       line coming out of the number. Anchor to the .sp-n box instead: vertically
       on its centre, horizontally just off the edge that faces the product.
       (Tom 08-11) */
    /* RANGE THE DIGITS, NOT THE ELEMENT. .sp-n is display:block, so its box is
       the full width of the call-out — anchoring to it put the line's origin at
       the paragraph edge again, which is the bug this was meant to fix. A Range
       over its text node gives the box of "01" itself. */
    const nEl = it.el.querySelector(".sp-n");
    let nb = b;
    if (nEl && nEl.firstChild && nEl.firstChild.nodeType === 3) {
      const rg = document.createRange();
      rg.selectNodeContents(nEl);
      const rr = rg.getBoundingClientRect();
      if (rr.width) nb = rr;
    }
    const NGAP = 5;                       // clear air between the digits and the stroke
    let sx = (it.side === "left" ? b.right : b.left) - sec.left;
    const sy = nb.top + nb.height / 2 - sec.top;
    // the horizontal run stops short of the product's silhouette on its own side
    const runY  = it.half === "top" ? y0 + INSET : y1 - INSET;
    const [rowL, rowR] = widthAtRow(runY);
    const stopX = it.side === "left" ? rowL - GAP : rowR + GAP;
    // ONE continuous path: the call-out's own rule IS the first leg, so the rule
    // and the leader are a single stroke instead of a CSS border that merely sits
    // near an SVG line. (Tom 08-09) — and that first leg now begins at the
    // number rather than at the far edge of the paragraph (Tom 08-11)
    const outX = (it.side === "left" ? nb.right + NGAP : nb.left - NGAP) - sec.left;
    /* THE ELBOW'S CORNER HAS TO CLEAR THE PRODUCT TOO — phone only.
       On the web the four call-outs sit in the corners of a wide screen, so the
       corner (sx) is always well outside the metal. On a phone they are a
       two-column grid running the full width and the product is centred over the
       middle of it, so sx landed ON the silhouette and the elbow's VERTICAL leg
       ran straight down through the jewelry. Only the horizontal run was ever
       checked against the product. Push the corner outside the widest reading
       the silhouette has over the rows that leg actually travels, by the same
       GAP — and never past the call-out's own digits. (Tom 08-11) */
    if (MOB) {
      const a = Math.min(sy, runY), z = Math.max(sy, runY);
      let lo = Infinity, hi = -Infinity;
      for (let i = 0; i <= 8; i++) {
        const [l, r] = widthAtRow(a + ((z - a) * i) / 8);
        if (l < lo) lo = l;
        if (r > hi) hi = r;
      }
      if (isFinite(lo) && isFinite(hi)) {
        sx = it.side === "left" ? Math.max(outX, Math.min(sx, lo - GAP))
                                : Math.min(outX, Math.max(sx, hi + GAP));
      }
    }
    // never let the elbow double back past the call-out itself
    const endX = it.side === "left" ? Math.max(stopX, sx) : Math.min(stopX, sx);
    it.ln.setAttribute("points", `${outX},${sy} ${sx},${sy} ${sx},${runY} ${endX},${runY}`);
    // slide in from its own side, so nothing ever crosses the product
    const slide = MOB ? 0 : (1 - alpha) * 90 * (it.side === "left" ? -1 : 1);   // phone: already out, fade only
    it.ln.setAttribute("transform", `translate(${slide.toFixed(2)},0)`);
    it.ln.setAttribute("opacity", alpha.toFixed(3));
  });
}

let canvasLive = true;
function animate() {
  const t = Date.now() * 0.001;
  const heroProg = Math.min(scrollY / (vh * 2), 1);

  floaters.forEach((f) => {
    const u = f.userData;
    const bob = Math.sin(t * floatSpd + u.phase) * floatAmp;
    f.position.y += bob - (u._lastBob || 0);
    u._lastBob = bob;
    if (u.sway) {
      // pendants/huggies: big lively swing around the front anchor — never a full spin
      f.rotation.y = u.yaw0 + Math.sin(t * 0.85 + u.phase) * 1.15;
      f.rotation.x = u.tilt0 + u.exitSpin;             // 360 exit = end-over-end (horizontal axis, like the original)
    } else if (u.spin) {
      f.rotation.y = u.yaw0 + t * 0.55;                // tiles: true continuous spin (no "back" to hide)
      f.rotation.x = u.tilt0 + u.exitSpin;
    } else if (u.floatPose) {
      const k = u.poseK != null ? u.poseK : 0.5 - 0.5 * Math.cos(t * 0.5);   // front -> semi-side -> front
      const r = mixPose(u.poseA, u.poseB, k);
      f.rotation.set(r[0] + u.exitSpin, r[1], r[2]);
    } else if (u.upright) {
      const amp = f === heroCan ? 0.22 : 0.3;          // both studs stay forward-facing (Tom 08-08); gentle rock only
      f.rotation.y = u.yaw0 + Math.sin(t * 0.6 + u.phase) * amp;
      f.rotation.x = u.tilt0 + u.exitSpin;
    } else {
      f.rotation.x = heroProg * Math.PI * 2 * u.tumble + Math.sin(t * 0.4 + u.phase) * 0.08;
      f.rotation.y += 0.0012 * u.tumble;
    }
  });

  updateCollection(t);
  drawCallouts();

  /* SKIP WHAT HAS SHRUNK TO NOTHING. Once the hero exits, nine of the ten
     floaters sit at scale 0 for the rest of the page, but three.js still drew
     all of them every frame: ~440k triangles of pendant and hoop nobody could
     see, on every frame of every later section. Hidden for this one pass only
     and restored right after, so nothing else that owns .visible (heroCan, the
     exit tweens) ever sees the change. (Tom 10-15: "make it load fast and smooth") */
  const _shrunk = [];
  for (const f of floaters) if (f.visible && Math.abs(f.scale.x) < 0.002) { f.visible = false; _shrunk.push(f); }
  /* PAUSE THE CANVAS WHEN THERE IS NOTHING ON IT. A full-screen transparent
     WebGL canvas that is redrawn every frame costs the compositor a full blend
     of the page even when it is empty: measured on Tom's AMD laptop, an EMPTY
     transparent canvas redrawn each frame caps the page near 39-49fps, and
     hiding it takes the same spot to 120fps. So when no hero piece, no card
     piece and no tile in flight is showing, the canvas is hidden and nothing is
     drawn; it comes back the frame something appears. (Tom 10-15) */
  const liveFloaters = floaters.some((f) => f.visible) ;
  const liveCards = collPieces.some((q) => q.wrap.visible);
  const liveFly = flyWrap.children.length > 0;
  const live = liveFloaters || liveCards || liveFly;
  if (live !== canvasLive) { canvasLive = live; renderer.domElement.style.visibility = live ? "" : "hidden"; }
  if (!live) { for (const f of _shrunk) f.visible = true; requestAnimationFrame(animate); return; }
  renderer.render(scene, camera);
  for (const f of _shrunk) f.visible = true;
  renderer.autoClear = false;              // card products drawn over the page, undistorted
  renderer.clearDepth();

  /* THE WORKSPACE IS A WINDOW, NOT A STAGE THE PIECE CAN WALK OFF.
     Scale a piece up on the bench — or click a tile onto an already-large one —
     and it used to keep drawing straight out over the section, because every
     product on this page is rendered into ONE fixed full-screen canvas that sits
     above the layout. No amount of overflow:hidden on .st-stage can clip that:
     the DOM element is only a rectangle we aim at, the pixels are not inside it.

     So the bench piece is drawn in its own pass with a SCISSOR set to the stage
     rect. Anything past the border is cut off — you cannot see outside the
     viewport, which is what Tom asked for, rather than the camera pulling back to
     keep the whole piece in frame. Everything else (deck cards, rail thumbnails)
     renders in the normal pass, unchanged. (Tom 08-11) */
  const bp = typeof benchCardEl !== "undefined" && benchCardEl ? deckPieceOf.get(benchCardEl) : null;
  const stageEl = benchCardEl ? benchCardEl.querySelector(".st-stage") : null;
  const bpVisible = bp ? bp.wrap.visible : false;
  if (bp) bp.wrap.visible = false;          // held out of the unclipped pass
  if (liveCards) renderer.render(deckScene, deckCam);   // no card piece showing = no second full-screen pass (Tom 10-15)
  if (bp && bpVisible && stageEl) {
    const sr = stageEl.getBoundingClientRect();
    const onScreen = sr.width > 0 && sr.height > 0 && sr.bottom > 0 && sr.top < window.innerHeight;
    if (onScreen) {
      collPieces.forEach((q) => { q._svis = q.wrap.visible; q.wrap.visible = q === bp; });
      renderer.setScissorTest(true);
      // WebGL's origin is bottom-left; the DOM's is top-left
      renderer.setScissor(sr.left, VH - sr.bottom, sr.width, sr.height);
      renderer.clearDepth();
      renderer.render(deckScene, deckCam);
      renderer.setScissorTest(false);
      collPieces.forEach((q) => { q.wrap.visible = q._svis; });
    }
    bp.wrap.visible = bpVisible;
  }
  if (flyWrap.children.length) {           // tiles in flight sit over everything
    syncFlyWrap();
    renderer.clearDepth();
    renderer.render(flyScene, deckCam);
  }
  renderer.autoClear = true;
  requestAnimationFrame(animate);
}
